// Auto-generated — refresh via scripts/translate-ui-google-free.mjs
// Placeholders repaired via scripts/repair-ui-placeholders.mjs

export const UI_MESSAGES_FIL: Record<string, string> = {
  'maintenance.title': 'Kasalukuyang nasa maintenance',
  'maintenance.defaultMessage':
    'Kasalukuyang nasa maintenance ang system at pansamantalang hindi magagamit. Pakisubukan ulit mamaya.',
  'common.loading': 'Naglo-load…',
  'common.datePlaceholder': 'Pumili ng petsa',
  'common.openCalendarAria': 'Buksan ang kalendaryo para pumili ng petsa',
  'common.cancel': 'Kanselahin',
  'common.close': 'Isara',
  'common.closeViewer': 'Isara ang preview',
  'common.imageViewer.zoomHint': 'Kurutin upang mag-zoom; i-double-tap upang i-reset; o gamitin ang + / − sa ibaba',
  'common.imageViewer.zoomInAria': 'Mag-zoom in',
  'common.imageViewer.zoomOutAria': 'Mag-zoom out',
  'common.imageViewer.resetZoomAria': 'I-reset ang zoom',
  'common.imageViewer.scalePercent': '{{percent}}%',
  'common.confirm': 'Kumpirmahin',
  'common.next': 'Susunod',
  'common.back': 'Bumalik',
  'common.save': 'I-save',
  'common.appTagline': 'Pamamahala ng Sambahayan para sa mga Employer at Katulong',
  'common.languageSwitcherAria': 'Wika ng interface',
  'notFound.title': 'Hindi nahanap ang page',
  'notFound.body': 'Ang page na hinahanap mo ay wala o naalis na.',
  'language.zhHant': 'Tradisyunal na Tsino',
  'language.zhHans': 'Pinasimpleng Tsino',
  'language.en': 'Ingles',
  'language.id': 'Indonesian',
  'language.fil': 'Filipino',
  'legal.contentEnglishNotice': 'Ang nilalaman ng pahinang ito ay ipinapakita sa Ingles.',
  'login.title': 'Mag-login',
  'login.subtitle': 'Mag-sign in gamit ang iyong email at password',
  'auth.errorGeneric': 'Nagkaproblema. Pakisubukang muli.',
  'auth.emailLabel': 'Email',
  'auth.passwordLabel': 'Password',
  'auth.rememberMe': 'Tandaan mo ako',
  'auth.forgotPasswordLink': 'Nakalimutan ang password?',
  'auth.signIn': 'Mag-sign in',
  'auth.signInWithGoogle': 'Mag-sign in gamit ang Google',
  'auth.signingIn': 'Nagsa-sign in…',
  'auth.linkRegister': 'Gumawa ng account',
  'auth.linkLogin': 'Mayroon ka nang account? Mag-sign in',
  'auth.registerTitle': 'Gumawa ng account',
  'auth.registerSubtitle': 'Piliin ang iyong tungkulin at ilagay ang iyong mga detalye',
  'auth.roleLabel': 'Tungkulin',
  'auth.roleRequired': 'Mangyaring pumili muna ng isang tungkulin.',
  'auth.passwordRulesHint': '8–16 na character na may uppercase, lowercase, at isang digit',
  'auth.nicknameLabel': 'palayaw',
  'auth.pairingCodeOptional': 'Code ng pagpapares (opsyonal)',
  'auth.pairingCodePlaceholder': '6 na karakter',
  'auth.pairingCodeHint': 'Kung binigyan ka ng iyong employer ng code, ilagay ito dito. Maaari ka ring magparehistro muna at ilagay ang code sa pahina ng pagpapares sa ibang pagkakataon.',
  'auth.invitationCodeLabel': 'Code ng imbitasyon',
  'auth.invitationCodeOptional': 'Code ng imbitasyon (opsyonal)',
  'auth.invitationCodePlaceholder': '8 mga character',
  'auth.invitationCodeHint': 'Maglagay ng code ng imbitasyon kung mayroon ka.',
  'auth.invitationCodeRequired': 'Mangyaring magpasok ng code ng imbitasyon',
  'auth.invitationCodeValid': 'May bisa ang code ng imbitasyon',
  'auth.invitationCodeBenefitL1Extend': 'Pahabain ang trial ng {{days}} araw',
  'auth.invitationCodeBenefitL3Trial': 'Paid-member trial ng {{days}} araw',
  'auth.invitationCodeInvalid': 'Di-wasto ang code ng imbitasyon',
  'auth.invitationCodeErrorFormat': 'Di-wasto ang format ng code ng imbitasyon',
  'auth.invitationCodeErrorNotYetActive': 'Ang code ng imbitasyon ay hindi pa aktibo',
  'auth.invitationCodeErrorExpired': 'Ang code ng imbitasyon ay nag-expire na',
  'auth.invitationCodeErrorDisabled': 'Ang code ng imbitasyon ay hindi pinagana',
  'auth.invitationCodeErrorMaxUses': 'Naabot na ng code ng imbitasyon ang limitasyon sa paggamit nito',
  'auth.invitationCodeErrorAfterRegistrationOnly':
    'Ang invitation code na ito ay maaari lang i-redeem pagkatapos magrehistro',
  'auth.invitationCodeDeepLinkInvalid':
    'Hindi valid o hindi na available ang invite link na ito. Maglagay ng ibang valid na invitation code kung mayroon ka.',
  'auth.invitationCodeLockedHint':
    'Ang invitation code na ito ay galing sa invite link at hindi mababago sa pagpaparehistro.',
  'inviteReferrer.menuItem': 'Paggamit ng invitation code',
  'inviteReferrer.pageTitle': 'Paggamit ng invitation code',
  'inviteReferrer.pageSubtitle':
    'Tingnan kung ilan ang gumamit ng iyong invitation code sa pagpaparehistro o pag-redeem, at ilan ang naging paying users.',
  'inviteReferrer.statsLabel': 'Stats ng invitation code',
  'inviteReferrer.code': 'Invitation code',
  'inviteReferrer.benefit': 'Benepisyo ng code',
  'inviteReferrer.benefitL1Extend': 'Palawigin ang trial ng {{days}} araw',
  'inviteReferrer.benefitL3Trial': 'Premium membership trial sa loob ng {{days}} araw',
  'inviteReferrer.maxUses': 'Limitasyon sa paggamit',
  'inviteReferrer.maxUsesLimited': '{{used}} / {{max}}',
  'inviteReferrer.maxUsesUnlimited': '{{used}} / Walang limitasyon',
  'inviteReferrer.validity': 'Panahon ng bisa',
  'inviteReferrer.validityRange': '{{start}} — {{end}}',
  'inviteReferrer.validityImmediate': 'Agarang epektibo',
  'inviteReferrer.validityPermanent': 'Walang petsa ng pagtatapos',
  'inviteReferrer.totalUses': 'Kabuuang paggamit',
  'inviteReferrer.paidUsers': 'Paying users',
  'inviteReferrer.shareLink': 'Share link',
  'inviteReferrer.copyLink': 'Kopyahin ang link',
  'inviteReferrer.copied': 'Nakopya',
  'inviteReferrer.notBound': 'Hindi ka pa naka-bind bilang referrer ng invitation code.',
  'auth.registerCta': 'Magrehistro',
  'auth.registerWithGoogle': 'Magrehistro sa Google',
  'auth.registering': 'Nagrerehistro…',
  'auth.registerRoleConfirmTitle': 'Kumpirmahin ang iyong tungkulin sa pagpaparehistro',
  'auth.registerRoleConfirmDescription': 'Ang iyong napiling tungkulin ay "{{role}}". Pakikumpirma na ito ay tama. Ang iyong tungkulin ay hindi mababago pagkatapos ng pagpaparehistro.',
  'auth.registerPicsScrollRequired': 'Paki-scroll muna ang Personal Information Collection Statement (PICS) sa ibaba.',
  'auth.registerPicsAgreeRequired': 'Pakilagyan ng check ang kahon upang sumang-ayon sa Pahayag sa Pagkolekta ng Personal na Impormasyon.',
  'auth.forgotTitle': 'Nakalimutan ang password',
  'auth.forgotSubtitle': 'Ilagay ang iyong email at magpapadala kami ng link sa pag-reset kung mayroon ang account.',
  'auth.forgotSubmit': 'Magpadala ng link sa pag-reset',
  'auth.forgotSending': 'Ipinapadala…',
  'auth.forgotSuccess': 'Kung nakarehistro ang email na iyon, makakatanggap ka ng email sa pag-reset ng password sa ilang sandali.',
  'auth.resetTitle': 'I-reset ang password',
  'auth.resetSubtitle': 'Pumili ng bagong password.',
  'auth.newPasswordLabel': 'Bagong password',
  'auth.confirmPasswordLabel': 'Kumpirmahin ang bagong password',
  'auth.resetSubmit': 'I-reset ang password',
  'auth.resetting': 'Nire-reset…',
  'auth.passwordMismatch': 'Hindi tugma ang mga password',
  'auth.showPassword': 'Ipakita',
  'auth.hidePassword': 'Magtago',
  'auth.confirmPasswordRegisterLabel': 'Kumpirmahin ang password',
  'auth.resetSuccess': 'Na-reset ang iyong password. Mangyaring mag-sign in.',
  'auth.goToLogin': 'Pumunta sa pag-login',
  'auth.goToHome': 'Pumunta sa bahay',
  'auth.verifyTitle': 'I-verify ang email',
  'auth.verifyPending': 'Bine-verify…',
  'auth.verifySuccess': 'Matagumpay na na-verify ang email.',
  'auth.verifyFail': 'Nabigo ang pag-verify. Maaaring nag-expire na ang link.',
  'auth.missingToken': 'Di-wasto o nawawalang link sa pag-verify.',
  'auth.accountRemovalConfirmTitle': 'Kumpirmahin ang pagbura ng account',
  'auth.accountRemovalConfirmPrompt': 'Agad na mabubura ang iyong account pagkatapos pindutin ang button sa ibaba. Hindi na ito maibabalik.',
  'auth.accountRemovalConfirmButton': 'Kumpirmahin at burahin ang account',
  'auth.accountRemovalConfirmPending': 'Binubura ang iyong account…',
  'auth.accountRemovalConfirmSuccess': 'Nabura na ang iyong account.',
  'auth.accountRemovalConfirmFail': 'Nabigo ang pagkumpirma. Maaaring nag-expire na ang link.',
  'auth.googleCallbackTitle': 'Nagsa-sign in gamit ang Google',
  'auth.googleCallbackLoading': 'Tinatapos ang Google authentication. Mangyaring maghintay…',
  'auth.googleDecisionNotRegistered': 'Walang nakitang tala sa pagpaparehistro para sa Google account na ito. Gusto mo bang magparehistro ngayon?',
  'auth.googleDecisionRegisteredGoogle': 'Mayroon nang talaan sa pagpaparehistro ng Google. Gusto mo bang mag-sign in ngayon?',
  'auth.googleDecisionRegisteredEmail': 'Mayroon nang email/password account para sa email na ito. Gusto mo bang mag-sign in gamit ang email sa halip?',
  'auth.googleDecisionConfirmRegister': 'Oo, magparehistro ngayon',
  'auth.googleDecisionConfirmLogin': 'Oo, mag-sign in ngayon',
  'auth.googleDecisionConfirmEmailLogin': 'Oo, gumamit ng email sign in',
  'auth.googleDecisionCancelHome': 'Hindi, bumalik sa bahay',
  'auth.registerWizardStepBadge': 'Hakbang {{current}} ng {{total}}',
  'auth.registerWizardProgressAria': 'Pag-unlad ng pagpaparehistro',
  'auth.registerMethodTitle': 'Gumawa ng account',
  'auth.registerMethodSubtitle': 'Piliin kung paano mo gustong magparehistro para sa MaidEasy.',
  'auth.registerDividerOrEmail': 'O magrehistro gamit ang email',
  'auth.registerEmailHelper': 'Magpapadala kami ng link sa pag-verify sa email na ito.',
  'auth.registerContinueWithEmail': 'Magpatuloy sa email',
  'auth.registerStepRoleTitle': 'Piliin ang iyong tungkulin',
  'auth.registerStepRoleSubtitle': 'Pakipili kung ikaw ay Employer o Helper. Hindi na ito mababago sa ibang pagkakataon.',
  'auth.registerRoleImportantNotice': 'Mahalaga: Kapag napili mo ang iyong tungkulin at nakumpleto ang pagpaparehistro, hindi na ito mababago. Tiyaking pipiliin mo ang tamang tungkulin.',
  'auth.registerRoleEmployerTitle': 'Employer',
  'auth.registerRoleEmployerDesc': 'Gusto kong pamahalaan ang mga gawain, gastos, at kumonekta sa aking katulong.',
  'auth.registerRoleHelperTitle': 'Katulong',
  'auth.registerRoleHelperDesc': 'Gusto kong tingnan ang aking mga pang-araw-araw na gawain, magsumite ng mga resibo, at subaybayan ang aking trabaho.',
  'auth.registerStepNicknameTitle': 'Ipasok ang mga detalye',
  'auth.registerStepNicknameSubtitle': 'Ang pangalang ito ay ipinapakita sa iyong ipinares na partido; rehiyon ng paggamit at palayaw ay maaaring baguhin sa ibang pagkakataon sa Mga Setting.',
  'auth.registerStepPasswordTitle': 'Itakda ang iyong password',
  'auth.registerStepPasswordSubtitle': 'Mangyaring lumikha ng isang secure na password upang maprotektahan ang iyong account.',
  'auth.registerPasswordPolicyTitle': 'Ang password ay dapat maglaman ng hindi bababa sa:',
  'auth.registerPasswordPolicyLength': '8–16 na karakter',
  'auth.registerPasswordPolicyUpper': 'Isang malaking titik (A–Z)',
  'auth.registerPasswordPolicyLower': 'Isang maliit na titik (a–z)',
  'auth.registerPasswordPolicyDigit': 'Isang numero (0–9)',
  'auth.registerStepPairingTitle': 'Code ng pagpapares (opsyonal)',
  'auth.registerStepPairingSubtitle': 'Kung ang iyong tagapag-empleyo ay nagbahagi ng 6-character na code ng pagpapares, ilagay ito dito. Maaari mo ring iwanan itong blangko at ipares sa ibang pagkakataon.',
  'auth.registerStepPicsScrollFirst': 'I-scroll ang pahayag sa ibaba hanggang sa ibaba bago mo malagyan ng tsek ang pahintulot.',
  'auth.registerContinue': 'Magpatuloy',
  'auth.registerStepReviewTitle': 'Suriin ang iyong mga detalye',
  'auth.registerStepReviewSubtitle': 'Pakikumpirma na tama ang impormasyon sa ibaba. Gamitin ang I-edit upang bumalik sa isang hakbang.',
  'auth.registerReviewMethod': 'Paraan ng pagpaparehistro',
  'auth.registerReviewMethodEmail': 'Email',
  'auth.registerReviewMethodGoogle': 'Google',
  'auth.registerReviewRole': 'Tungkulin ng account',
  'auth.registerReviewEmail': 'Email address',
  'auth.registerReviewNickname': 'palayaw',
  'auth.registerReviewUsageRegion': 'Rehiyon ng paggamit',
  'auth.registerReviewPairing': 'Code ng pagpapares',
  'auth.registerReviewPairingEmpty': '(Hindi ibinigay)',
  'auth.registerReviewInvitationCode': 'Code ng imbitasyon',
  'auth.registerReviewInvitationCodeEmpty': 'Hindi ginagamit',
  'auth.registerReviewPicsAgreed': 'Sumang-ayon ka sa Personal Information Collection Statement (PICS) at mga tuntunin sa pagproseso ng data.',
  'auth.registerReviewEdit': 'I-edit',
  'auth.registerCompleteRegistration': 'Kumpletuhin ang pagpaparehistro',
  'auth.registerCompleteTitle': 'Kumpleto na ang pagpaparehistro',
  'auth.registerCompleteEmailVerify': 'Nagpadala kami ng email sa pagpapatunay. Pakisuri ang iyong inbox (at spam) at i-click ang link upang i-verify.',
  'auth.registerCompleteGoogle': 'Na-verify na ang iyong Google account. Maaari mong ipagpatuloy ang paggamit ng MaidEasy.',
  'auth.registerCompleteContinue': 'Magpatuloy',
  'auth.emailTaken': 'Nakarehistro na ang email na ito',
  'auth.emailChecking': 'Sinusuri ang email...',
  'auth.emailInvalid': 'Mangyaring magpasok ng wastong email address',
  'home.navLogin': 'Mag-sign in',
  'home.navLoginEmail': 'Email sign in',
  'home.navGoogleLogin': 'Mag-sign in gamit ang Google',
  'home.navRegister': 'Magrehistro',
  'home.registerModalTitle': 'Pumili ng paraan ng pagpaparehistro',
  'home.registerModalSubtitle': 'Mangyaring piliin ang pagpaparehistro sa Google o pagpaparehistro sa email.',
  'home.registerWithGoogle': 'Magrehistro sa Google',
  'home.registerWithEmail': 'Magrehistro gamit ang email',
  'home.navLogout': 'Log out',
  'home.navPairing': 'Katayuan ng pagpapares',
  'home.navEmployerApp': 'Mga gawain (employer)',
  'home.navHelperApp': 'Mga gawain ngayon (katulong)',
  'home.phaseLine': '',
  'home.linkPrivacy': 'Patakaran sa Privacy',
  'home.linkTerms': 'Mga Tuntunin ng Serbisyo',
  'home.linkPics': 'PICS',
  'home.linkFaq': 'FAQ',
  'home.linkFeatures': 'Mga Tampok',
  'home.linkFeaturesAria': 'Mga Tampok (magbubukas sa bagong tab)',
  'faq.title': 'Mga Madalas Itanong',
  'faq.subtitle': 'Tingnan ang FAQ na nilalaman ayon sa tungkulin.',
  'faq.tabHelper': 'Katulong',
  'faq.tabEmployer': 'Employer',
  'faq.loadError': 'Hindi ma-load ang FAQ.',
  'faq.empty': 'Wala pang FAQ content.',
  'nav.home': 'Home',
  'systemMessage.menu': 'Mga system message',
  'systemMessage.list.title': 'Mga system message',
  'systemMessage.list.empty': 'Wala pang system message.',
  'systemMessage.list.colSubject': 'Subject',
  'systemMessage.list.colDate': 'Petsa',
  'systemMessage.list.openItem': 'Buksan: {{subject}}',
  'systemMessage.ticker.title': 'System message',
  'systemMessage.ticker.count': '{{current}} / {{total}}',
  'systemMessage.ticker.openDetails': 'Tingnan ang detalye ng system message',
  'systemMessage.ticker.prev': 'Nakaraang system message',
  'systemMessage.ticker.next': 'Susunod na system message',
  'systemMessage.action.close': 'Isara',
  'systemMessage.detailEmpty': '(Walang detalye)',
  'systemMessage.error.loadList': 'Hindi ma-load ang mga system message',
  'systemMessage.image.enlargeAria': 'Palakihin ang imahe',
  'systemMessage.image.openLinkAria': 'Buksan ang link',
  'systemMessage.menuItemUnreadAria': '{{label}}, {{count}} hindi pa nababasa',
  'nav.tasks': 'Mga gawain',
  'nav.expensesSettlements': 'Mga gastos',
  'nav.expensesSettlementsHelper': 'Mga gastos',
  'nav.family': 'Pamilya',
  'nav.stock': 'Stock',
  'nav.mainAria': 'Pangunahing app na nabigasyon sa ibaba',
  'pwa.offlineBanner': 'Offline — Pansamantalang hindi available ang App na ito hanggang sa maibalik ang iyong network.',
  'pwa.syncing': 'Sini-sync…',
  'pwa.syncComplete': 'Kumpleto na ang pag-sync',
  'pwa.syncFailed': 'Nabigo ang pag-sync — pakisubukang muli',
  'pwa.pendingSync': 'Mga item na nakabinbing pag-sync',
  'pwa.installCta': 'I-install ang app',
  'pwa.installDismiss': 'Isara',
  'playBanner.subtitle': 'MaidEasy - Sa Google Play',
  'playBanner.install': 'I-install',
  'playBanner.installAria': 'I-install ang MaidEasy sa Google Play',
  'playBanner.dismissAria': 'Isara ang banner ng pag-install',
  'playBanner.regionAria': 'Prompt sa pag-install ng Google Play',
  'task.complete.savedOffline': 'Naka-save sa device na ito; magsi-sync kapag online',
  'receipt.analyze.savedOffline': 'Naka-save sa device na ito; magsi-sync kapag online',
  'legal.privacy.title': 'Patakaran sa Privacy',
  'legal.privacy.body': 'Ang page na ito ay placeholder legal na nilalaman. Inilalarawan nito kung paano namin kinokolekta, ginagamit, at pinoprotektahan ang personal na data, at legal na susuriin bago ang produksyon.',
  'legal.terms.title': 'Mga Tuntunin ng Serbisyo',
  'legal.terms.body': 'Ang page na ito ay placeholder legal na nilalaman. Ang paggamit ng serbisyo ay napapailalim sa mga tuntuning dapat tapusin bago ilunsad ang produksyon.',
  'legal.pics.title': 'Pahayag sa Pagkolekta ng Personal na Impormasyon (PICS)',
  'legal.pics.body': 'Multi-language PICS placeholder na nakahanay sa daloy ng pagpaparehistro; huling kopya pagkatapos ng legal/compliance review.',
  'legal.backHome': 'Bumalik sa bahay',
  'settings.title': 'Mga setting',
  'settings.subtitle': 'Wika, timezone, hitsura, at mga notification',
  'settings.nicknameLabel': 'palayaw',
  'settings.nicknamePlaceholder': 'Ilagay ang iyong palayaw',
  'settings.languageLabel': 'Ipakita ang wika',
  'settings.timezoneLabel': 'Timezone',
  'settings.usageRegionLabel': 'Rehiyon ng paggamit',
  'settings.themeLabel': 'Tema',
  'settings.themeLight': 'Liwanag',
  'settings.themeDark': 'Madilim',
  'settings.themeSystem': 'Sistema',
  'settings.fontSizeLabel': 'Laki ng font',
  'settings.fontXSmall': 'Sobrang liit',
  'settings.fontSmall': 'Maliit',
  'settings.fontMedium': 'Katamtaman',
  'settings.fontLarge': 'Malaki',
  'settings.fontXLarge': 'Sobrang laki',
  'settings.aiUsageTitle': 'Ang paggamit ng AI ngayon',
  'settings.aiUsageHint': 'resibo ng AI at pagtatasa ng stock sa bahay (nagre-reset araw-araw sa UTC 00:00)',
  'settings.receiptUsageTitle': 'Ang paggamit ngayon ng pag-scan ng resibo',
  'settings.receiptUsageHint': 'Mga resibo na maaari mong isumite bawat araw (nagre-reset araw-araw sa UTC 00:00)',
  'settings.aiUsageLoading': 'Naglo-load…',
  'settings.dailyUsageError': 'Hindi ma-load ang pang-araw-araw na paggamit',
  'usage.pageTitle': 'Buod ng paggamit',
  'usage.pageSubtitle': 'Araw-araw na quota at limitasyon ng gawain',
  'usage.backToSettings': 'Bumalik sa mga setting',
  'usage.taskSubmitTitle': 'Paggamit ng pagsusumite ng gawain ngayon',
  'usage.taskSubmitHint': 'Mga pagsusumite ng gawain bawat araw (nagre-reset araw-araw sa UTC 00:00)',
  'usage.taskReviewTitle': 'Paggamit ng pagsusuri ng gawain ngayon',
  'usage.taskReviewHint': 'Mga pagsusuri ng gawain bawat araw (nagre-reset araw-araw sa UTC 00:00)',
  'usage.totalTasksTitle': 'Kabuuang mga gawaing nalikha',
  'usage.totalTasksHint': 'Mga slot ng gawain sa pares (hindi binibilang ang naka-archive na gawain)',
  'usage.pinMessagesTitle': 'Kabuuang mga pin message',
  'usage.pinMessagesHint': 'Bilang ng pin message sa pares (kumulatibo)',
  'usage.resetAtLabel': 'Susunod na reset',
  'usage.unlimited': 'Walang limitasyon',
  'usage.viewUsageDetails': 'Tingnan ang detalye ng paggamit',
  'usage.membershipLevel': 'Antas ng membership',
  'usage.levelTrial': 'Trial member',
  'usage.levelFree': 'Free member',
  'usage.levelPaid': 'Premium member',
  'usage.helperMembershipHelpTriggerAria': 'Tingnan ang tulong sa antas ng membership',
  'usage.helperMembershipHelpAria': 'Tulong sa antas ng membership',
  'usage.helperMembershipHelpTitle': 'Antas ng membership',
  'usage.helperMembershipHelpFollowsEmployer':
    'Hindi maaaring mag-upgrade ng membership ang Helper nang mag-isa. Sumusunod ang antas ng membership sa account ng employer.',
  'usage.helperMembershipHelpContactEmployer':
    'Kung kulang ang usage quota, makipag-ugnayan sa iyong employer para mag-upgrade.',
  'usage.helperSectionTitle': 'Narito ang paggamit ng Helper',
  'usage.compareLevels': 'Ihambing ang antas',
  'usage.upgradeBannerBefore': 'I-click ',
  'usage.upgradeBannerClickHere': 'dito',
  'usage.upgradeBannerAfter': ' para mag-upgrade sa Premium at i-unlock ang usage at features',
  'usage.upgradeBannerClickAria': 'Pumunta sa membership subscription',
  'usage.playStoreUpgradeNotice':
    'Para mag-upgrade o pamahalaan ang subscription, buksan ang serbisyo sa browser o sa Add to Home Screen app (hindi nag-aalok ng bayad sa subscription ang Google Play app).',
  'membership.restoreModal.title': 'I-restore ang naka-archive na gawain',
  'membership.restoreModal.description': 'Na-upgrade ang iyong membership. Piliin ang home stock, pickup/drop-off, o medication reminder na gusto mong i-restore. Mananatiling naka-archive ang hindi napili.',
  'membership.restoreModal.confirm': 'I-restore ang napili',
  'membership.restoreModal.skip': 'Hindi muna',
  'membership.restoreModal.success': 'Na-restore ang mga napiling gawain',
  'membership.restoreModal.error': 'Hindi ma-restore ang mga gawain. Subukan muli.',
  'membership.pricing.compareTitle': 'Ihambing ang antas ng membership',
  'membership.pricing.loading': 'Naglo-load ng membership plans…',
  'membership.pricing.loadError': 'Hindi ma-load ang pricing ngayon. Subukan muli mamaya.',
  'membership.pricing.priceUnavailable': '—',
  'membership.pricing.monthlyFeeLabel': 'Buwanan:',
  'membership.pricing.yearlyFeeLabel': 'Taunan:',
  'membership.pricing.cheaperBadge': 'Mas murang ang taunang plano',
  'membership.pricing.discountUntil': 'Diskwento hanggang {date}',
  'membership.pricing.welcomeRemark': 'Unang buwan {first}, pagkatapos {thereafter}',
  'membership.pricing.trialStartsOnRegister': 'Magsisimula ang trial pagkatapos magparehistro',
  'membership.pricing.yes': 'Oo',
  'membership.pricing.no': 'Hindi',
  'subscription.openPage': 'Membership subscription',
  'subscription.title': 'Membership subscription',
  'subscription.membershipLevel': 'Membership level',
  'subscription.previousSubscriptionTitle': 'Previous premium subscription',
  'subscription.previousSubscriptionEnded': 'Your previous premium subscription has ended',
  'subscription.previousSubscriptionPaymentFailed':
    'Your previous premium subscription has ended (payment previously failed)',
  'subscription.trialEndsAt': 'Magtatapos ang trial member period',
  'subscription.invitationTrialEndsAt': 'Magtatapos ang premium membership trial ng invitation code',
  'subscription.subscriptionEndsAt': 'Magtatapos ang subscription',
  'subscription.nextChargeAt': 'Susunod na singil',
  'subscription.payToday': 'Maging premium member ngayon para ma-unlock ang higit pang features',
  'subscription.startTrial': 'I-set up ang subscription (walang singil sa trial)',
  'subscription.payTodayAmount': '{{amount}} lang {{period}}',
  'subscription.noChargeToday': 'Walang bayarin ngayon',
  'subscription.promoPriceFirstMonth': 'Unang buwan {{dueAmount}}, pagkatapos {{listPrice}} {{period}}',
  'subscription.promoPriceLimitedTime':
    '{{dueAmount}} {{period}} sa promo (hanggang {{endsAt}}), pagkatapos {{listPrice}} {{period}}',
  'subscription.promoAppliedFirstMonth': 'Unang buwan na promo: bawas {{amount}}',
  'subscription.promoAppliedLimitedTime':
    'Limitadong panahon na promo: bawas {{amount}} (hanggang {{endsAt}})',
  'subscription.firstChargeAmount': 'Unang singil {{amount}}',
  'subscription.coversPeriod': 'Unang bayad na period: {{start}} hanggang {{end}}',
  'subscription.nextCharge': 'Susunod na singil: {{date}}',
  'subscription.firstChargeOn': 'Unang singil sa {{date}}',
  'subscription.invitationTrialNote':
    'Invitation trial hanggang {{date}}; walang dagdag na bayad sa panahon ng trial.',
  'subscription.invitationTrialChargeLaterNote':
    'Invitation trial hanggang {{date}}; magsisimula ang unang singil sa araw ng pagtatapos ng trial.',
  'subscription.subscribeButton': 'Magbayad at mag-subscribe',
  'subscription.resubscribeButton': 'Mag-subscribe muli sa premium',
  'subscription.startTrialButton': 'I-set up ang subscription',
  'subscription.stripeCheckoutDiscountHiddenNote':
    'Ang susunod na payment page ay magpapakita lang ng walang bayad ngayon at ng regular na presyo. Hindi nito maipapakita ang discount. Awtomatikong ilalapat ang discount sa unang singil.',
  'subscription.promoMayExpireIfDeferred':
    'Maaaring matapos ang limited-time offer bago ang unang singil, kaya maaaring regular na presyo ang sisingilin.',
  'subscription.termsTitle': 'Mga Tuntunin at Kundisyon ng Subscription',
  'subscription.termsLinkLabel': 'Mga Tuntunin at Kundisyon ng Subscription',
  'subscription.termsConsentPay':
    'Sa pagpili ng “{{buttonLabel}}” at pagbabayad, sumasang-ayon ka sa {{termsLink}}.',
  'subscription.termsConsentSetup':
    'Sa pagpili ng “{{buttonLabel}}”, sumasang-ayon ka sa {{termsLink}}.',
  'subscription.termsLoadError': 'Hindi ma-load ang mga tuntunin ng subscription. Subukan muli.',
  'subscription.alreadySubscribed': 'Mayroon ka nang aktibong bayad na subscription.',
  'subscription.stripeNotConfigured': 'Hindi pa naka-enable ang subscription sa environment na ito.',
  'subscription.loadError': 'Hindi ma-load ang detalye ng subscription. Subukan muli.',
  'subscription.checkoutSuccess': 'Matagumpay na na-set up ang subscription.',
  'subscription.checkoutCancel': 'Kinansela ang bayad.',
  'subscription.manageButton': 'Pamahalaan ang subscription',
  'subscription.playStoreBillingNotice':
    'Hindi available sa Google Play app ang subscribe, pamahalaan ang subscription, o palitan ang plano.',
  'subscription.playStoreOfficialWebsiteLine':
    'Pakigamit ang browser upang buksan ang opisyal na website ng MaidEasy\n{{url}}',
  'subscription.invoicesTitle': 'Mga kamakailang invoice',
  'subscription.viewInvoiceButton': 'Tingnan ang invoice',
  'subscription.statusActive': 'Status ng subscription: aktibo',
  'subscription.statusPastDue': 'Status ng subscription: nabigo ang bayad',
  'subscription.statusCanceled': 'Status ng subscription: kinansela',
  'subscription.willAutoRenewOn': 'Awtomatikong mare-renew ang iyong subscription sa {{date}}',
  'subscription.willAutoRenewOnWithAmount':
    'Awtomatikong mare-renew ang iyong subscription sa {{date}} ({{amount}})',
  'subscription.willAutoRenewOnPromo':
    'Awtomatikong mare-renew ang iyong subscription sa {{date}} (promo {{amount}})',
  'subscription.nextRenewLimitedTimePromo':
    'Limitadong panahon: {{dueAmount}} {{period}} (hanggang {{endsAt}}, regular na presyo {{listPrice}})',
  'subscription.periodPerMonth': 'kada buwan',
  'subscription.periodPerYear': 'kada taon',
  'subscription.willEndOnCancelled': 'Magtatapos ang iyong subscription sa {{date}} (nakansela ang subscription)',
  'subscription.intervalMonth': 'Buwanan',
  'subscription.intervalYear': 'Taunan',
  'subscription.selectBillingInterval': 'Piliin ang billing interval',
  'subscription.planUnavailable': 'Hindi pa available ang billing interval na ito.',
  'subscription.currentBillingInterval': 'Kasalukuyang plano: {{interval}}',
  'subscription.pendingIntervalChange':
    'Naka-schedule na magpalit sa {{interval}} sa {{date}} (magkakabisa pagkatapos ng kasalukuyang period)',
  'subscription.lockedPromoReserved':
    'Nakareserba ang diskwento na {{amount}} para sa iyo (mas magandang offer sa araw ng singil ay awtomatikong gagamitin)',
  'subscription.cancelIntervalChange': 'Kanselahin ang naka-schedule na pagpapalit',
  'subscription.switchToYear': 'Lumipat sa taunan (susunod na period)',
  'subscription.switchToMonth': 'Lumipat sa buwanan (susunod na period)',
  'subscription.intervalChangeNote':
    'Magkakabisa ang pagpapalit pagkatapos matapos ang kasalukuyang plano.',
  'subscription.intervalChangeScheduled': 'Naka-schedule ang pagpapalit ng billing interval.',
  'subscription.intervalChangeCancelled': 'Nakansela ang naka-schedule na pagpapalit.',
  'subscription.intervalChangeConfirmTitleYear': 'Kumpirmahin ang paglipat sa taunan',
  'subscription.intervalChangeConfirmTitleMonth': 'Kumpirmahin ang paglipat sa buwanan',
  'subscription.intervalChangeConfirmIntro':
    'Kasalukuyan kang nasa {{current}}. Magkakabisa ang paglipat sa {{target}} pagkatapos matapos ang kasalukuyang plano.',
  'subscription.intervalChangeConfirmEffectiveAt': 'Magkakabisa / matatapos ang kasalukuyang plano',
  'subscription.intervalChangeConfirmFirstChargeAt': 'Unang singil para sa bagong plano',
  'subscription.intervalChangeConfirmCoversPeriod': 'Unang coverage period ng bagong plano',
  'subscription.intervalChangeConfirmCoversPeriodValue': '{{start}} hanggang {{end}}',
  'subscription.intervalChangeConfirmAmount': 'Tinatayang unang singil',
  'subscription.intervalChangeConfirmPromoLimited':
    'Limited-time discount ngayon: bawas {{amount}} (hanggang {{endsAt}}; mas magandang offer sa araw ng singil ay awtomatikong gagamitin)',
  'subscription.intervalChangeConfirmPromoGeneric': 'Kasalukuyang discount: bawas {{amount}}',
  'subscription.intervalChangeConfirmNotes': 'Mga paalala',
  'subscription.intervalChangeConfirmNoRefund':
    'Mananatiling aktibo ang kasalukuyang plano hanggang matapos ito.',
  'subscription.intervalChangeConfirmPromoLockNote':
    'Kapag kinumpirma, irereserba ang limited-time offer ngayon. Kung may mas magandang offer sa araw ng singil, iyon ang gagamitin; kung wala, mananatili ang naka-reserve na offer.',
  'subscription.intervalChangeConfirmButtonYear': 'Kumpirmahin ang paglipat sa taunan',
  'subscription.intervalChangeConfirmButtonMonth': 'Kumpirmahin ang paglipat sa buwanan',
  'subscription.cancelIntervalChangeConfirmTitle': 'Kumpirmahin ang pagkansela ng naka-schedule na pagpapalit',
  'subscription.cancelIntervalChangeConfirmIntro':
    'Ikakansela ang naka-schedule na paglipat sa {{interval}} sa {{date}}. Mananatili ka sa kasalukuyang plano.',
  'subscription.cancelIntervalChangeConfirmPromoNote':
    'Maaalis din ang naka-reserve na diskwento na {{amount}}.',
  'subscription.cancelIntervalChangeConfirmButton': 'Kumpirmahin ang pagkansela',
  'membership.restoreTask.action': 'I-restore ang gawain',
  'membership.restoreTask.success': 'Na-restore ang gawain',
  'admin.upgradeToL3': 'I-upgrade sa L3 (test)',
  'admin.upgradeToL3Confirm': 'I-upgrade ang employer na ito sa L3? Mare-restore ang auto-translation preferences at lalabas ang restore prompt sa susunod na dashboard visit.',
  'admin.upgradeToL3Success': 'Na-upgrade sa L3.',
  'admin.upgradeToL3Error': 'Hindi ma-upgrade sa L3.',
  'admin.grantL3TrialTitle': 'Magbigay ng L3 trial',
  'admin.grantL3TrialHint': 'Ilagay ang petsa at oras ng pagtatapos. Mananatili ang employer sa L3 at ise-save ito bilang pagtatapos ng invitation L3 trial.',
  'admin.grantL3TrialField': 'Magtatapos ang trial sa (lokal na oras)',
  'admin.grantL3TrialButton': 'Magbigay ng L3 trial',
  'admin.grantL3TrialConfirm': 'Magbigay ng L3 trial sa employer na ito?',
  'admin.grantL3TrialSuccess': 'Naibigay ang L3 trial.',
  'admin.grantL3TrialError': 'Hindi maibigay ang L3 trial.',
  'admin.grantL3TrialDateRequired': 'Ilagay muna ang petsa at oras ng pagtatapos ng trial.',
  'limitModal.title.default': 'Naabot na ang limitasyon ng paggamit',
  'limitModal.title.batchInsufficient': 'Hindi sapat ang araw-araw na quota',
  'limitModal.title.TOTAL_TASK_LIMIT_REACHED': 'Naabot na ang limitasyon sa paggawa ng gawain',
  'limitModal.title.COMMENT_LIMIT_REACHED': 'Naabot na ang limitasyon sa komento',
  'limitModal.title.DAILY_TASK_SUBMIT_LIMIT_REACHED': 'Naabot na ang pang-araw-araw na pagsusumite ng gawain',
  'limitModal.title.DAILY_TASK_REVIEW_LIMIT_REACHED': 'Naabot na ang pang-araw-araw na pagsusuri ng gawain',
  'limitModal.title.DAILY_RECEIPT_LIMIT_REACHED': 'Naabot na ang pang-araw-araw na limitasyon ng resibo',
  'limitModal.title.DAILY_AI_ANALYZE_LIMIT_REACHED': 'Naabot na ang pang-araw-araw na limitasyon ng AI',
  'limitModal.title.TASK_KIND_NOT_ALLOWED': 'Hindi available ang uri ng gawain',
  'limitModal.title.AUTO_TRANSLATION_NOT_ALLOWED': 'Hindi available ang auto-translation',
  'limitModal.title.INVENTORY_LOCATION_LIMIT_REACHED': 'Naabot na ang limitasyon sa lokasyon ng inventory',
  'limitModal.title.INVENTORY_CATEGORY_LIMIT_REACHED': 'Naabot na ang limitasyon sa kategorya ng inventory',
  'limitModal.title.PIN_MESSAGE_LIMIT_REACHED': 'Naabot na ang limitasyon sa pin message',
  'limitModal.body.TOTAL_TASK_LIMIT_REACHED': 'Nakagawa ka na ng {{total}}/{{max}} na gawain (hindi binibilang ang naka-archive).',
  'limitModal.body.COMMENT_LIMIT_REACHED': 'Umabot na sa {{total}}/{{max}} ang mga komento para sa item na ito.',
  'limitModal.body.DAILY_TASK_SUBMIT_LIMIT_REACHED': 'Nagsumite ng {{used}}/{{limit}} ngayon. Susunod na reset: {{retryAt}}.',
  'limitModal.body.DAILY_TASK_REVIEW_LIMIT_REACHED': 'Nagsuri ng {{used}}/{{limit}} ngayon. Susunod na reset: {{retryAt}}.',
  'limitModal.body.DAILY_RECEIPT_LIMIT_REACHED': 'Nagsumite ng {{used}}/{{limit}} na resibo ngayon. Susunod na reset: {{retryAt}}.',
  'limitModal.body.DAILY_AI_ANALYZE_LIMIT_REACHED': 'Gumamit ng {{used}}/{{limit}} na AI analysis ngayon. Susunod na reset: {{retryAt}}.',
  'limitModal.body.batchInsufficient.DAILY_RECEIPT_LIMIT_REACHED':
    'May {{remaining}} na natitirang pagsusumite ng resibo ngayon ({{used}}/{{limit}} nagamit), hindi sapat para isumite ang {{requested}} na resibo. Susunod na reset: {{retryAt}}.',
  'limitModal.body.batchInsufficient.DAILY_AI_ANALYZE_RECEIPT':
    'May {{remaining}} na natitirang AI analysis ngayon ({{used}}/{{limit}} nagamit), hindi sapat para suriin ang {{requested}} na resibo. Susunod na reset: {{retryAt}}.',
  'limitModal.body.batchInsufficient.DAILY_AI_ANALYZE_PHOTO':
    'May {{remaining}} na natitirang AI analysis ngayon ({{used}}/{{limit}} nagamit), hindi sapat para suriin ang {{requested}} na larawan. Susunod na reset: {{retryAt}}.',
  'limitModal.body.TASK_KIND_NOT_ALLOWED': 'Hindi sinusuportahan ng iyong membership level ang uri ng gawain na ito.',
  'limitModal.body.AUTO_TRANSLATION_NOT_ALLOWED': 'Hindi sinusuportahan ng iyong membership level ang auto-translation.',
  'limitModal.body.INVENTORY_LOCATION_LIMIT_REACHED': 'Naabot na ang bilang ng lokasyon ng inventory para sa iyong membership.',
  'limitModal.body.INVENTORY_CATEGORY_LIMIT_REACHED': 'Naabot na ang bilang ng kategorya ng inventory para sa iyong membership.',
  'limitModal.body.PIN_MESSAGE_LIMIT_REACHED': 'Nakagawa ka na ng {{total}}/{{max}} na pin message.',
  'limitModal.title.PIN_MESSAGE_ACTIVE_LIMIT_REACHED': 'Naabot na ang limitasyon sa aktibong pin message',
  'limitModal.body.PIN_MESSAGE_ACTIVE_LIMIT_REACHED':
    'Lumampas ang kabuuang pin message sa free membership cap. Pinakamaraming {{max}} ang maaaring active nang sabay ({{total}} active ngayon). I-deactivate ang iba o mag-upgrade ng membership.',
  'limitModal.body.default': 'Naabot na ng iyong account ang limitasyon para sa kasalukuyang membership level.',
  'limitModal.helperHint': 'Makipag-ugnayan sa iyong employer para mag-upgrade at makakuha ng mas mataas na quota.',
  'limitModal.employerDailyHint': 'Tingnan ang pahina ng paggamit para sa detalye; mas mataas ang quota kapag nag-upgrade.',
  'limitModal.employerTotalTasksHint': 'Maaari kang mag-upgrade para makagawa ng mas maraming gawain.',
  'limitModal.employerTaskKindHint': 'Mag-upgrade ng membership para magamit ang uri ng gawaing ito.',
  'limitModal.employerPinMessagesHint': 'Maaari kang mag-upgrade para makapagdagdag ng mas maraming pin message.',
  'limitModal.employerL3Hint':
    'Naabot mo na ang limitasyon ng kasalukuyang plano. Maaari mong tingnan ang detalye sa pahina ng paggamit.',
  'limitModal.close': 'Isara',
  'limitModal.viewUsage': 'Tingnan ang detalye ng paggamit',
  'limitModal.goSubscription': 'Pumunta sa subscription / upgrade',
  'limitModal.playStoreBillingHint':
    'Hindi maproseso ang upgrade dito sa Google Play app. Pamahalaan ang subscription sa browser o Add to Home Screen app.',
  'settings.notifyEmailLabel': 'Magpadala rin ng mga notification ng aktibidad sa pamamagitan ng email',
  'settings.autoTranslationLabel': 'Awtomatikong isalin ang tekstong inilagay ng kabilang partido',
  'settings.autoTranslationHint':
    'Kapag naka-off, ang mga komento, paglalarawan ng gawain, atbp. ay orihinal na teksto lamang at hindi tatawagin ang serbisyo ng pagsasalin.',
  'settings.notifyWebPushLabel': 'Makatanggap ng mga notification sa device na ito (Web Push)',
  'settings.webPushToggleError': 'Hindi ma-update ang setting ng notification',
  'settings.notifyWebPushPermissionDeniedHint': 'Naka-block ang pahintulot sa notification ng browser. Mangyaring payagan ang mga notification sa mga setting ng site ng browser, pagkatapos ay i-refresh ang pahinang ito.',
  'settings.webPushPromptTitle': 'Paganahin ang mga push notification',
  'settings.webPushPromptBody': 'Payagan ang mga notification na makatanggap ng gawain at suriin ang mga update sa real time.',
  'settings.webPushPromptEnable': 'Payagan ang mga notification',
  'settings.androidChromePushHintTitle': 'Kailangan ng Chrome para sa system push',
  'settings.androidChromePushHintBody':
    'Hindi sapat ang support ng browser na ito para sa Web Push. I-install o i-update ang pinakabagong Chrome para makatanggap ng real-time na task at review alerts. Gumagana pa rin ang in-app bell notifications.',
  'settings.androidChromePushHintCta': 'I-install / i-update ang Chrome',
  'settings.androidChromePushHintDismiss': 'Mamaya na',
  'settings.save': 'I-save ang mga setting',
  'settings.saving': 'Sine-save...',
  'settings.saved': 'Nai-save',
  'settings.invitationCodeTitle': 'I-redeem ang invitation code',
  'settings.invitationCodeSubscriptionTitle': 'May invitation code?',
  'settings.invitationCodeHint': 'Maglagay ng 8-character code para pahabain ang trial o mag-upgrade sa paid-member trial.',
  'settings.invitationCodeInputLabel': 'Invitation code',
  'settings.invitationCodeInputPlaceholder': 'Ilagay ang 8-character code',
  'settings.invitationCodeRedeemButton': 'I-redeem',
  'settings.invitationCodeRedeemSuccess': 'Matagumpay na na-redeem ang invitation code',
  'settings.invitationCodeRedeemFailed': 'Hindi ma-redeem ang invitation code. Subukan muli.',
  'settings.invitationCodeInvalid': 'Hindi valid ang invitation code',
  'settings.invitationCodeErrorRegistrationOnly':
    'Ang invitation code na ito ay maaari lang gamitin sa pagpaparehistro',
  'settings.invitationCodeErrorNotL1Trial': 'Para lang sa trial membership ang code na ito',
  'settings.invitationCodeErrorL1TrialEnded': 'Tapos na ang iyong trial',
  'settings.invitationCodeErrorSubscriptionActive': 'May aktibong bayad na subscription ka na',
  'settings.invitationCodeErrorEmailAlreadyUsed': 'Nagamit mo na ang invitation code na ito',
  'settings.invitationCodePreviewL1Extend': 'Pahabain ang trial ng {{days}} araw. Bagong petsa: {{endsAt}}',
  'settings.invitationCodePreviewL3Trial': 'Mag-upgrade sa paid-member trial ng {{days}} araw. Magtatapos: {{endsAt}}',
  'settings.invitationCodePreviewL3SubscriptionExtend': 'Pahabain ang subscription ng {{days}} araw. Bagong petsa: {{endsAt}}',
  'settings.loadError': 'Hindi ma-load ang mga setting',
  'settings.saveError': 'Nabigo ang pag-save',
  'settings.logout': 'Log out',
  'settings.logoutConfirmTitle': 'Log out?',
  'settings.logoutConfirmDescription': 'Kakailanganin mong mag-sign in muli upang magamit ang iyong account.',
  'settings.changePassword': 'Baguhin ang password',
  'settings.changePasswordHint': 'Baguhin ang password dito habang naka-sign in.',
  'settings.googlePasswordManagedHint': 'Ang account na ito ay gumagamit ng Google sign-in at hindi sumusuporta sa pagbabago o pag-reset ng password.',
  'settings.currentPasswordLabel': 'Kasalukuyang password',
  'settings.newPasswordLabel': 'Bagong password',
  'settings.confirmNewPasswordLabel': 'Kumpirmahin ang bagong password',
  'settings.changePasswordSubmit': 'I-update ang password',
  'settings.changePasswordSaving': 'Ina-update…',
  'settings.changePasswordSuccess': 'Na-update ang password. Mangyaring mag-sign in muli.',
  'settings.changePasswordError': 'Hindi mapalitan ang password',
  'settings.changePasswordCurrentPasswordIncorrect': 'Mali ang kasalukuyang password. Pakisubukang muli.',
  'settings.expandChangePasswordSectionAria': 'Palawakin ang seksyon ng pagbabago ng password',
  'settings.collapseChangePasswordSectionAria': 'I-collapse ang seksyon ng pagbabago ng password',
  'settings.expandAccountRemovalSectionAria': 'Palawakin ang seksyon ng pagbura ng account',
  'settings.collapseAccountRemovalSectionAria': 'I-collapse ang seksyon ng pagbura ng account',
  'settings.resendVerification': 'Muling ipadala ang verification email',
  'settings.resendVerificationSending': 'Ipinapadala…',
  'settings.resendVerificationSuccess': 'Ipinadala ang email ng pagpapatunay. Suriin ang iyong inbox.',
  'settings.resendVerificationError': 'Nabigo ang pagpapadala',
  'settings.resendVerificationCooldown': 'Mangyaring maghintay ng 15 minuto bago humiling ng isa pang email sa pagpapatunay.',
  'settings.emailUnverifiedBanner': 'Hindi pa nabe-verify ang iyong email. Hindi mo magagamit ang mga feature ng app na ito.',
  'settings.accountRemovalPasswordLabel': 'Ilagay ang iyong password para kumpirmahin',
  'settings.accountRemovalGoogleHint': 'Pagkatapos isumite, magpapadala ng confirmation email. Buksan ang link sa loob ng 30 minuto, tapos pindutin ang kumpirmahin sa page. Agad na mabubura ang account pagkatapos kumpirmahin.',
  'settings.backToPairingStatus': 'Bumalik sa katayuan ng pagpapares',
  'settings.mainMenuAria': 'Pangunahing menu',
  'settings.menuHome': 'Home',
  'settings.menuTasksEmployer': 'Mga gawain',
  'settings.menuTasksHelper': 'Listahan ng mga gawain',
  'settings.menuSettlements': 'Mga gastos at settlement',
  'settings.menuMoneyGiven': 'Ibinigay ng Pera',
  'settings.menuSettlementRecords': 'Mga talaan ng settlement',
  'settings.menuPinMessages': 'I-pin ang mga setting ng mensahe',
  'settings.menuBudgets': 'Pamamahala ng Binigyang Pera',
  'settings.menuReceipts': 'I-scan ang Mga Resibo',
  'settings.menuReceiptBrowse': 'Listahan ng resibo',
  'settings.menuFamily': 'Mga Kagustuhan sa Miyembro ng Pamilya',
  'settings.menuPairingStatus': 'Katayuan ng pagpapares',
  'settings.menuConfirmSettlement': 'Kumpirmahin ang settlement',
  'settings.menuSettings': 'Mga setting',
  'settings.menuOverview': 'Pangkalahatang-ideya',
  'settings.menuAccountSettings': 'Mga setting ng account',
  'settings.menuSubscriptionAndInvite': 'Membership at i-redeem ang invitation code',
  'settings.menuMoneyGivenSettlement': 'Pera na Ibinigay at Settlement',
  'settings.menuTodayTask': 'Gawain ngayong araw',
  'settings.menuImportPreviousPairing': 'Import from previous pairing',
  'pairing.import.title': 'Import from previous pairing',
  'pairing.import.description':
    'Copy tasks, family members, and pin messages from your most recent ended pairing into the current one. Nothing is selected by default — tick the items you want.',
  'pairing.import.later': 'Later',
  'pairing.import.import': 'Import',
  'pairing.import.sectionTasks': 'Tasks',
  'pairing.import.sectionFamily': 'Family members',
  'pairing.import.sectionPins': 'Pin messages',
  'pairing.import.alreadyImported': 'Already imported',
  'pairing.import.consentLabel':
    'I confirm importing the selected family members and that their existing consent flags apply.',
  'pairing.import.empty':
    'Nothing to import (items may already be imported, or the previous pairing had no data).',
  'pairing.import.success': 'Selected items were imported',
  'pairing.import.error': 'Could not import. Please try again.',
  'pairing.import.loadError': 'Could not load import options. Please try again.',
  'pairing.import.taskQuotaHint': 'Task slots: {{used}}/{{max}} (archived tasks not counted)',
  'pairing.import.pinQuotaHint': 'Pin messages: {{used}}/{{max}}',
  'pairing.import.taskKindStandard': 'Standard task',
  'previousHelper.detailBanner':
    'Ang gawaing ito ay hinawakan ng dating Helper. Hindi makikita ng kasalukuyang Helper ang record na ito.',
  'previousHelper.receiptBanner':
    'Ang resibong ito ay isinumite ng dating Helper. Hindi makikita ng kasalukuyang Helper ang record na ito.',
  'previousHelper.settlementBanner':
    'Ang settlement na ito ay isinumite ng dating Helper. Hindi makikita ng kasalukuyang Helper ang record na ito.',
  'previousHelper.unpairedDetailBanner':
    'Ang record na ito ay mula sa natapos na pagpapares. Hindi ito makikita ng bagong Helper pagkatapos magpares.',
  'previousHelper.unpairedReceiptBanner':
    'Ang resibong ito ay mula sa natapos na pagpapares. Hindi ito makikita ng bagong Helper pagkatapos magpares.',
  'previousHelper.unpairedSettlementBanner':
    'Ang settlement na ito ay mula sa natapos na pagpapares. Hindi ito makikita ng bagong Helper pagkatapos magpares.',
  'pairing.unpairedBanner':
    'Hindi ka pa nakapares sa Helper. Maaari ka nang gumawa ng gawain, pin message, miyembro ng pamilya, at perang ibinigay. Makikita ito ng Helper pagkatapos magpares.',
  'pairing.unpairedBannerAction': 'Gumawa ng pairing code',
  'pairing.unpairedBannerAria': 'Hindi pa nakapares',
  'settings.accountRemoval': 'Burahin ang account',
  'settings.accountRemovalHint': 'Pagkatapos ilagay ang password at isumite, agad na mabubura ang account at hindi na maibabalik.',
  'settings.accountRemovalSubmit': 'Kumpirmahin at burahin ang account',
  'settings.accountRemovalSuccess': 'Naipadala na ang confirmation email. Buksan ang link sa loob ng 30 minuto, tapos pindutin ang kumpirmahin sa page para burahin ang account.',
  'settings.accountRemovalDeleted': 'Nabura na ang iyong account.',
  'settings.accountRemovalError': 'Nabigo ang kahilingan. Pakisubukang muli mamaya.',
  'settings.accountRemovalPasswordIncorrect': 'Maling password. Pakisubukang muli.',
  'settings.closePanel': 'Isara',
  'toast.offlineQueued': 'Idinagdag sa offline na pila. Awtomatiko itong magsi-sync kapag online.',
  'toast.task.createSuccess': 'Matagumpay na nagawa ang gawain!',
  'toast.task.updateSuccess': 'Matagumpay na na-save ang gawain!',
  'toast.task.completeSuccess': 'Matagumpay na naisumite ang pagkumpleto ng gawain!',
  'toast.task.resubmitSuccess': 'Matagumpay na naisumite muli ang gawain!',
  'toast.task.reviewedSuccess': 'Matagumpay na nasuri ang gawain!',
  'toast.task.needUpdateSuccess': 'Matagumpay na na-update ang gawain bilang mga pangangailangan!',
  'toast.receiptAnalyze.singleSavedOnline':
    'Na-save ang resibo. Susunod: isumite ang settlement sa employer',
  'toast.receiptAnalyze.singleSavedStillUnsaved':
    'Na-save ang resibo. May {{count}} pang resibo na hindi pa na-save — i-save muna lahat.',
  'toast.receiptAnalyze.singleSavedOffline': 'Na-save ang resibo sa offline na pila.',
  'toast.receiptAnalyze.batchAllOnlineSuccess': 'Tapos na ang batch: Matagumpay na na-save ang {{successCount}} (mga) resibo.',
  'toast.receiptAnalyze.batchAllOfflineQueued': 'Tapos na ang batch: {{queuedCount}} (mga) resibo ang idinagdag sa offline na pila.',
  'toast.receiptAnalyze.batchMixedOnlineOfflineSuccess': 'Tapos na ang batch: {{onlineCount}} na-save, {{queuedCount}} nakapila offline.',
  'toast.receiptAnalyze.batchPartialResult': 'Tapos na ang batch: {{onlineCount}} na-save, {{queuedCount}} nakapila offline, {{failedCount}} failed.',
  'toast.receipt.editSuccess': 'Matagumpay na na-save ang resibo!',
  'toast.receipt.deleteSuccess': 'Matagumpay na natanggal ang resibo!',
  'toast.budget.createSuccess': 'Matagumpay na nalikha ang Money Given!',
  'toast.budget.updateSuccess': 'Matagumpay na nai-save ang Money Given!',
  'toast.budget.deleteSuccess': 'Matagumpay na naalis ang Money Given!',
  'toast.pinMessage.createSuccess': 'Matagumpay na nagawa ang mensahe ng pin!',
  'toast.pinMessage.updateSuccess': 'Matagumpay na na-save ang mensahe ng pin!',
  'toast.pinMessage.deleteSuccess': 'Matagumpay na naalis ang mensahe ng pin!',
  'toast.familyMember.createSuccess': 'Matagumpay na naidagdag ang miyembro ng pamilya!',
  'toast.familyMember.updateSuccess': 'Matagumpay na na-update ang miyembro ng pamilya!',
  'toast.familyMember.deleteSuccess': 'Matagumpay na naalis ang miyembro ng pamilya!',
  'toast.settings.updateSuccess': 'Matagumpay na na-save ang mga setting!',
  'toast.settings.changePasswordSuccess': 'Matagumpay na nabago ang password!',
  'toast.pairing.joinSuccess': 'Matagumpay na nakumpleto ang pagpapares!',
  'toast.pairing.unpairSuccess': 'Matagumpay na naalis ang pagpapares!',
  'toast.pairing.generateCodeSuccess': 'Matagumpay na nabuo ang code sa pagpapares!',
  'toast.consent.acceptSuccess': 'Matagumpay na naisumite ang pahintulot!',
  'toast.settlement.confirmSuccess': 'Matagumpay na naisumite ang settlement!',
  'toast.settlement.unlockSuccess': 'Matagumpay na na-unlock ang settlement!',
  'toast.settlement.withdrawSuccess': 'Matagumpay na na-withdraw ang settlement!',
  'toast.settlement.reviewedSuccess': 'Matagumpay na nasuri ang settlement!',
  'toast.settlement.rejectedSuccess': 'Matagumpay na tinanggihan ang kasunduan!',
  'toast.settlement.withdrawConfirmTitle': 'Bawiin ang settlement na ito?',
  'toast.settlement.withdrawConfirmBody': 'Pagkatapos ng withdrawal, ang settlement na ito ay mamarkahan bilang withdraw. Magpatuloy?',
  'pairing.generate.title': 'Bumuo ng code ng pagpapares',
  'pairing.generate.subtitle': 'Bumuo ng code na ibabahagi sa iyong katulong para sa pagpapares',
  'pairing.generate.errorGeneric': 'Nabigong bumuo ng code ng pagpapares',
  'pairing.generate.codeLabel': 'Ang iyong code ng pagpapares',
  'pairing.generate.validUntil': 'May bisa hanggang {{datetime}} ({{duration}})',
  'pairing.generate.durationMinutes': '{{count}} minuto',
  'pairing.generate.durationHours': '{{count}} oras',
  'pairing.generate.durationDay': '{{count}} araw',
  'pairing.generate.durationDays': '{{count}} araw',
  'pairing.generate.copyAria': 'Kopyahin ang code ng pagpapares sa clipboard',
  'pairing.generate.copied': 'Kinopya!',
  'pairing.generate.copyCode': 'Kopyahin ang code',
  'pairing.generate.regenerate': 'Magbagong-buhay',
  'pairing.generate.regenerating': 'Binubuo…',
  'pairing.generate.regenerateAria': 'Buuin muli ang code ng pagpapares',
  'pairing.generate.continue': 'Magpatuloy',
  'pairing.generate.continueAria': 'Magpatuloy sa susunod na hakbang',
  'pairing.generate.generateCta': 'Bumuo ng code ng pagpapares',
  'pairing.generate.generateAria': 'Bumuo ng code ng pagpapares',
  'pairing.generate.footer': 'Ibahagi ang link sa pagpaparehistro o QR code na ito sa iyong katulong. Awtomatiko silang ipapares sa iyo kapag nagparehistro sila.',
  'pairing.generate.qrAria': 'Link sa pagpaparehistro ng helper QR code',
  'pairing.generate.shareLabel': 'Ibahagi',
  'pairing.generate.shareAria': 'Ibahagi ang QR code at link sa pagpaparehistro',
  'pairing.generate.shareInviteTitle': 'Imbitasyon sa MaidEasy',
  'pairing.generate.shareInviteText':
    'Inaanyayahan ka ni {{nickname}} na gamitin ang MaidEasy. I-tap ang link o i-scan ang QR code para magparehistro.',
  'pairing.generate.shareEmployerFallback': 'Employer',
  'pairing.generate.shareError': 'Hindi maibahagi. Pakisubukan ulit.',
  'pairing.join.title': 'Ilagay ang code ng pagpapares',
  'pairing.join.subtitle': 'Ilagay ang 6-character code mula sa iyong employer upang ipares',
  'pairing.join.errorIncomplete': 'Pakipasok ang buong {{length}}-character code',
  'pairing.join.errorGeneric': 'Nabigo ang pagpapares',
  'pairing.join.pairing': 'Ipinapares...',
  'pairing.join.submit': 'Isumite ang code',
  'pairing.join.submitAria': 'Isumite ang code ng pagpapares',
  'pairing.join.inputGroupAria': 'Pagpares ng code input',
  'pairing.join.charAria': 'Code ng character {{n}}',
  'pairing.join.footer': 'Tanungin ang iyong employer para sa code ng pagpapares. Ang code ay may bisa sa loob ng {{duration}}.',
  'pairing.invite.landingTitle': 'Malapit ka nang ipares kay {{nickname}}',
  'pairing.invite.landingSubtitle': 'Mag-sign in o magparehistro para makumpleto ang pagpapares',
  'pairing.invite.emailLogin': 'Mag-sign in gamit ang email',
  'pairing.invite.googleLogin': 'Mag-sign in gamit ang Google',
  'pairing.invite.register': 'Magrehistro',
  'pairing.invite.invalidTitle': 'Di-wastong link ng pagpapares',
  'pairing.invite.errorInvalid': 'Ang pagpapares na link na ito ay hindi wasto o nag-expire na. Humingi ng bagong link sa iyong employer.',
  'pairing.invite.errorFormat': 'Di-wasto ang format ng code ng pagpapares.',
  'pairing.invite.previewError': 'Hindi ma-verify ang code ng pagpapares. Pakisubukang muli mamaya.',
  'pairing.invite.loginBanner': 'Pagkatapos mag-sign-in ay awtomatiko kang magpapares sa {{nickname}}.',
  'pairing.invite.registerBanner': 'Magrehistro bilang Helper at ipares si {{nickname}}',
  'pairing.invite.confirmTitle': 'Ipares sa {{nickname}}',
  'pairing.invite.confirmSubtitle': 'Makukumpleto kaagad ang pagpapares pagkatapos mong kumpirmahin',
  'pairing.invite.confirmCta': 'Kumpirmahin ang pagpapares',
  'pairing.invite.confirmDialogTitle': 'Ipares sa {{nickname}}?',
  'pairing.invite.confirmDialogDescription': 'Pagkatapos ng pagpapares maaari mong simulan ang paggamit ng MaidEasy.',
  'pairing.invite.employerSignedIn': 'Ang link na ito ay para sa Helpers. Naka-sign in ka bilang isang employer.',
  'pairing.invite.helperAlreadyPaired': 'Pares na kayo. Hindi kailangan ang link na ito.',
  'pairing.invite.goPairingStatus': 'Pumunta sa katayuan ng pagpapares',
  'pairing.invite.expiredTitle': 'Nag-expire ang link ng pagpapares',
  'pairing.invite.expiredBody': 'Maaaring nag-expire na o nagamit na ang pairing code.',
  'pairing.invite.contactEmployer': 'Di-wastong code ng pagpapares. Mangyaring makipag-ugnayan sa iyong employer.',
  'pairing.generate.copyInviteLink': 'Kopyahin ang link sa pagpaparehistro na may code ng pagpapares',
  'pairing.generate.copyInviteLinkAria': 'Kopyahin ang link sa pagpaparehistro ng Helper sa clipboard',
  'pairing.status.regenerateCode': 'Bumuo ng bagong code',
  'pairing.status.goGenerateNew': 'Bumuo ng bagong code ng pagpapares',
  'auth.googleLoginRequiredTitle': 'Mag-sign in gamit ang Google',
  'auth.googleLoginRequiredDescription': 'Ang email na ito ay dapat mag-sign in sa Google. Lumipat sa Google sign-in?',
  'auth.googleLoginRequiredConfirm': 'Mag-sign in gamit ang Google',
  'pairing.success.title': 'Matagumpay ang pagpapares!',
  'pairing.success.subtitle': 'Matagumpay kang naipares',
  'pairing.success.pairedWith': 'Ipinares sa',
  'pairing.success.nextTitle': 'Susunod: Kasunduan sa pahintulot',
  'pairing.success.nextBody': 'Kailangan mong suriin at tanggapin ang kasunduan sa pahintulot at Personal Information Collection Statement (PICS) bago mo simulang gamitin ang app.',
  'pairing.success.continue': 'Patuloy na pumayag',
  'pairing.success.continueAria': 'Patuloy na pumayag sa kasunduan',
  'pairing.success.nextTitleReady': 'Susunod: Simulan ang paggamit ng app',
  'pairing.success.nextBodyReady': 'Tinanggap mo na ang Personal Information Collection Statement (PICS) sa pagpaparehistro. Maaari mong ipasok ang app.',
  'pairing.success.continueApp': 'Pumunta sa app',
  'pairing.success.continueAppAria': 'Pumunta sa bahay ng app',
  'role.employer': 'Employer',
  'role.helper': 'Katulong',
  'pairing.status.loadingAria': 'Nilo-load ang katayuan ng pagpapares',
  'pairing.status.errorGeneric': 'Nabigong makuha ang katayuan ng pagpapares',
  'pairing.status.activeTitle': 'Aktibong pagpapares',
  'pairing.status.yourPartner': 'Yung partner mo',
  'pairing.status.pairedSince': 'Ipinares mula noong {{datetime}}',
  'pairing.status.notPairedTitle': 'Hindi pa nakapares',
  'pairing.status.emailUnverifiedHint': 'Hindi pa nabe-verify ang email. I-verify muna bago gamitin ang app.',
  'pairing.status.consentRequiredHint': 'Hindi pa kayo sumasang-ayon sa mga tuntunin. Sumang-ayon muna bago gamitin ang app.',
  'pairing.status.notPairedEmployer': 'Bumuo ng code ng pagpapares na ibabahagi sa iyong katulong',
  'pairing.status.notPairedHelper': 'Ilagay ang code ng pagpapares mula sa iyong employer',
  'pairing.status.goGenerate': 'Bumuo ng code ng pagpapares',
  'pairing.status.goEnter': 'Ilagay ang code ng pagpapares',
  'pairing.status.generateAria': 'Bumuo ng code ng pagpapares',
  'pairing.status.enterAria': 'Ilagay ang code ng pagpapares',
  'pairing.status.unpairButton': 'Alisin ang pagkakapares',
  'pairing.status.unpairAria': 'I-unpair ang kasalukuyang pagpapares',
  'pairing.status.unpairing': 'Inaalis ang pagpapares...',
  'pairing.status.unpairConfirm': 'Sigurado ka bang gusto mong i-unpair ang kasalukuyang pagpapares? Kakailanganin mong ipares muli pagkatapos.',
  'pairing.status.unpairError': 'Nabigong alisin ang pagkakapares. Pakisubukang muli mamaya.',
  'protected.loadingAria': 'Naglo-load',
  'app.autoUpdatingTitle': 'Awtomatikong ina-update ang app...',
  'app.autoUpdatingSlowHint': 'Ang pag-update ay tila mas mabagal kaysa sa inaasahan. Mangyaring maghintay...',
  'app.autoUpdatingVersionLine': 'Kasalukuyan: {{currentVer}} | Bago: {{newVer}}',
  'task.status.pending': 'Nakabinbin',
  'task.status.notSubmitted': 'Hindi isinumite',
  'task.status.approved': 'Naaprubahan',
  'task.status.rejected': 'Tinanggihan',
  'task.status.needsUpdate': 'Kailangan ng Update',
  'task.status.cancel': 'Kinansela',
  'receipt.status.save': 'Hindi pa nasettle',
  'receipt.status.submitted': 'Naisumite',
  'receipt.status.reviewed': 'Sinuri',
  'task.recurrence.none': 'minsan',
  'task.recurrence.daily': 'Araw-araw',
  'task.recurrence.weekly': 'Linggu-linggo',
  'task.recurrence.biweekly': 'Biweekly',
  'task.recurrence.monthly': 'Buwanan',
  'task.monthlyKind.day': 'Ayon sa petsa (ika-X araw ng buwan)',
  'task.monthlyKind.nthWeekday': 'Ika-N na araw ng linggo',
  'task.monthlyKind.lastWeekday': 'Huling araw ng linggo',
  'task.form.monthlyKindLabel': 'Panuntunan buwanan',
  'task.form.monthDaysLabel': 'Mga araw ng buwan',
  'task.form.monthlyOrdinalLabel': 'Ika-ilang pagkakataon',
  'task.form.monthlyOrdinal.1': 'Ika-1',
  'task.form.monthlyOrdinal.2': 'Ika-2',
  'task.form.monthlyOrdinal.3': 'Ika-3',
  'task.form.monthlyOrdinal.4': 'Ika-4',
  'task.form.monthlyOrdinal.5': 'Ika-5',
  'task.form.monthlyDayClampHint': 'Kung walang napiling petsa ang buwan (hal. 29–31), mapupunta ito sa huling araw ng buwan.',
  'task.form.monthlyFifthWeekdayHint': 'Kung walang ika-5 na pagkakataon ng napiling araw ng linggo, walang gawain sa buwang iyon.',
  'task.form.recurrenceMonthDaysRequired': 'Pumili ng kahit isang araw ng buwan.',
  'task.day.sun': 'Araw',
  'task.day.mon': 'Mon',
  'task.day.tue': 'Tue',
  'task.day.wed': 'Wed',
  'task.day.thu': 'Huwebes',
  'task.day.fri': 'Biyernes',
  'task.day.sat': 'Sab',
  'task.list.title': 'Pamamahala ng Gawain',
  'task.list.subtitle': 'Pamahalaan ang mga gawain para sa iyong katulong',
  'task.list.tabAll': 'Lahat',
  'task.list.tabToday': 'Ngayong araw',
  'task.list.tabRecurring': 'Paulit-ulit',
  'task.list.tabTodayTask': 'Ngayong araw',
  'task.list.tabEditTask': 'I-edit ang gawain',
  'task.list.tabOverdueTask': 'Mga overdue na gawain',
  'task.list.tabEffectiveTask': 'Mga Mabisang Gawain',
  'task.list.tabExpiredTask': 'Mga Nag-expire na Gawain',
  'task.list.addNew': 'Magdagdag ng Gawain',
  'task.list.addChoiceTitle': 'Ano ang gagawin',
  'task.list.addChoiceSubtitle': 'Piliin ang uri ng gawain na gusto mong gawin.',
  'task.list.addChoiceStandard': 'Lumikha ng Standard na gawain',
  'task.list.addChoiceInventory': 'Lumikha ng Home Stock',
  'task.list.addChoicePickupDropoff': 'Gumawa ng Pick up / Drop off Task',
  'task.list.addChoiceMedication': 'Gumawa ng Medication Reminder',
  'task.list.addChoiceLockedAria': 'Kailangan ng membership upgrade ang "{{label}}"',
  'task.list.kindStockTake': 'Home Stock',
  'task.list.kindPickupDropoff': 'Pick up / Drop off',
  'task.list.kindMedication': 'Paalala ng gamot',
  'task.pickup.loadError': 'Hindi ma-load ang data ng pickup/drop-off na gawain',
  'task.pickup.createHeading': 'Gumawa ng Pick up / Drop off Task',
  'task.pickup.editHeading': 'I-edit ang Pick up / Drop off na Gawain',
  'task.pickup.stepProgress': 'Hakbang {{step}} / {{total}}',
  'task.pickup.legHint': 'Piliin kung gagawa ng pick-up, drop-off, o pareho',
  'task.pickup.pickupLabel': 'Pick up',
  'task.pickup.dropoffLabel': 'I-drop off',
  'task.pickup.legRequired': 'Pumili ng hindi bababa sa Drop off o Pick up',
  'task.pickup.personLabel': 'Sino ang kukunin / ibababa',
  'task.pickup.personPlaceholder': 'hal. Dave',
  'task.pickup.suggestHeading': 'Mga mungkahi ng miyembro ng pamilya',
  'task.pickup.personRequired': 'Pakilagay kung sino ang kukunin / ibababa',
  'task.pickup.pickupTimeLabel': 'Oras ng pagkuha',
  'task.pickup.dropoffTimeLabel': 'Oras ng pagbaba',
  'task.pickup.pickupTimeRequired': 'Kinakailangan ang oras ng pagkuha',
  'task.pickup.dropoffTimeRequired': 'Ang oras ng pag-drop off ay kinakailangan',
  'task.pickup.timesMustDiffer': 'Magkaiba dapat ang mga oras ng pagbaba at Pagkuha',
  'task.pickup.locationLabel': 'Lokasyon (opsyonal)',
  'task.pickup.locationSuggestHeading': 'Mungkahi',
  'task.pickup.locationChip.school': 'Paaralan',
  'task.pickup.locationChip.tutoring': 'Klase ng pagtuturo',
  'task.pickup.locationChip.stadium': 'istadyum',
  'task.pickup.locationChip.soccerPitch': 'Soccer pitch',
  'task.pickup.locationChip.mall': 'Mall',
  'task.pickup.reviewPickupTitle': 'Kunin ang pamagat',
  'task.pickup.reviewDropoffTitle': 'I-drop off ang pamagat',
  'task.pickup.editTitleAria': 'I-edit ang pamagat ng gawain',
  'task.pickup.submitCreate': 'Gumawa ng Pick up / Drop off Task',
  'task.pickup.customTitleModalTitle': 'Custom na pamagat',
  'task.pickup.titleChoiceTitle': 'Paano i-update ang mga pamagat',
  'task.pickup.titleChoicePickup': 'Pick up',
  'task.pickup.titleChoiceDropoff': 'I-drop off',
  'task.pickup.titleChoiceKeep': 'Panatilihin ang orihinal na pamagat',
  'task.pickup.titleChoiceUseNew': 'Gumamit ng bagong pamagat',
  'task.pickup.titleChoiceCustom': 'Custom',
  'task.pickup.createSuccess': 'Nagawa ang pick up / drop off na gawain',
  'task.pickup.updateSuccess': 'Na-update ang pick up / drop off na gawain',
  'task.pickup.createError': 'Hindi makagawa ng Pick up / Drop off na gawain',
  'task.medication.loadError': 'Hindi ma-load ang data ng paalala ng gamot',
  'task.medication.createHeading': 'Gumawa ng Medication Reminder',
  'task.medication.editHeading': 'I-edit ang Paalala sa Gamot',
  'task.medication.stepProgress': 'Hakbang {{step}} / {{total}}',
  'task.medication.personLabel': 'Sino ang nangangailangan ng gamot',
  'task.medication.personPlaceholder': 'hal. Ben',
  'task.medication.suggestHeading': 'Mga mungkahi ng miyembro ng pamilya',
  'task.medication.personRequired': 'Pakilagay kung sino ang nangangailangan ng gamot',
  'task.medication.descPlaceholder': 'hal. Uminom ng gamot sa diabetes',
  'task.medication.timeRequired': 'Magdagdag ng kahit isang beses na gamot',
  'task.medication.timesUnique': 'Ang mga oras ng gamot ay dapat na natatangi',
  'task.medication.timeMax': 'Pinakamataas na 10 beses ng gamot',
  'task.medication.timesSectionLabel': 'Oras ng gamot',
  'task.medication.timeLabel': 'Oras ng gamot {{n}}',
  'task.medication.removeTimeAria': 'Alisin ang oras na ito',
  'task.medication.addTime': '+ Magdagdag ng oras ng gamot',
  'task.medication.reviewTitle': 'Pamagat ng gawain',
  'task.medication.editTitleAria': 'I-edit ang pamagat ng gawain',
  'task.medication.submitCreate': 'Gumawa ng Medication Reminder',
  'task.medication.customTitleModalTitle': 'Custom na pamagat',
  'task.medication.titleChoiceTitle': 'Paano i-update ang pamagat',
  'task.medication.titleChoiceKeep': 'Panatilihin ang orihinal na pamagat',
  'task.medication.titleChoiceUseNew': 'Gumamit ng bagong pamagat',
  'task.medication.titleChoiceCustom': 'Custom',
  'task.medication.createSuccess': 'Nagawa ang paalala ng gamot',
  'task.medication.updateSuccess': 'Na-update ang paalala ng gamot',
  'task.medication.createError': 'Hindi makalikha ng paalala ng gamot',
  'task.form.notifyEmployerLabel': 'Abisuhan ako kapag nakumpleto na',
  'task.form.remindHelperBeforeDueLabel': 'Paalalahanan ang katulong bago ang takdang oras',
  'task.form.remindHelperBeforeDueDisabledHint': 'Magtakda ng takdang oras bago paganahin ang paalala na ito.',
  'task.form.remindHelperBeforeDueModalTitle': 'Paalalahanan ang katulong bago ang takdang oras',
  'task.form.remindHelperBeforeDueModalIntro': 'Susubukan ng system na magpadala ng paalala sa loob ng 10 minuto bago ang takdang oras.',
  'task.form.remindHelperBeforeDueModalLimit1': 'Kailangang i-enable ng iyong helper ang mga notification (kailangan i-install o idagdag ang app sa home screen) o paganahin ang mga notification sa email para makatanggap ng mga napapanahong paalala.',
  'task.form.remindHelperBeforeDueModalLimit2': 'Ang iyong katulong ay nangangailangan ng koneksyon sa network kapag ipinadala ang paalala.',
  'task.form.remindHelperBeforeDueModalLimit3': 'Maaaring maantala ang aktwal na oras ng paghahatid dahil sa koneksyon sa network.',
  'task.medication.remindHelperBeforeDueModalIntro': 'Susubukan ng system na magpadala ng paalala sa loob ng 10 minuto bago ang oras ng gamot.',
  'task.medication.step3ReminderAskTitle': 'Paalalahanan ang katulong bago ang oras ng gamot?',
  'task.medication.step3ReminderAskYes': 'Oo, paganahin ang paalala',
  'task.medication.step3ReminderAskNo': 'Hindi, laktawan ang paalala',
  'task.group.wizard.stepOf': 'Hakbang {{current}} / {{total}}',
  'task.group.wizard.reviewCardHeadingPickup': 'Suriin ang pick up / drop off',
  'task.group.wizard.reviewCardHeadingMedication': 'Suriin ang paalala ng gamot',
  'task.group.wizard.reviewConfirmPickup': 'Gumawa ng pick up / drop off',
  'task.group.wizard.reviewConfirmMedication': 'Gumawa ng paalala ng gamot',
  'task.group.wizard.reviewUpdatePickup': 'I-save ang pick up / drop off',
  'task.group.wizard.reviewUpdateMedication': 'Paalala sa pag-save ng gamot',
  'task.group.wizard.summaryNone': '(Wala)',
  'task.group.wizard.summaryPerson': 'Tao',
  'task.group.wizard.summaryLocation': 'Lokasyon',
  'task.group.wizard.summaryExclusion': 'Mga saklaw ng pagbubukod',
  'task.group.wizard.summaryRequirePhoto': 'Mangailangan ng pagsusumite ng larawan',
  'task.group.wizard.summaryYes': 'Oo',
  'task.group.wizard.summaryNo': 'Hindi',
  'task.group.wizard.summaryMedicationTimes': 'Mga oras ng paalala',
  'task.list.empty': 'Wala pang gawain',
  'task.list.emptyHint': 'I-click ang button na Magdagdag ng Gawain upang gawin ang iyong unang gawain',
  'task.list.overdueEmpty': 'Walang overdue na gawain',
  'task.list.completedCount': 'Nakumpleto ang {{count}} beses',
  'task.list.pendingReviewNav': 'Nakabinbing mga gawain sa pagsusuri',
  'task.list.pendingReviewNavAria': 'Nakabinbing mga gawain sa pagsusuri, {{count}} (mga) item',
  'task.list.approvedNav': 'Naaprubahan',
  'task.list.approvedNavAria': 'Mga inaprubahang pagsusumite ng gawain, {{count}} (mga) item',
  'task.list.loadError': 'Nabigong i-load ang mga gawain',
  'task.list.pageSubtitle': 'Ang pag-unlad ngayon at pangkalahatang-ideya ng gawain',
  'task.list.summaryPendingLabel': 'Nakabinbing mga gawain sa pagsusuri',
  'task.list.summaryApprovedLabel': 'Naaprubahan',
  'task.list.summaryTomorrowLabel': 'Mga gawain bukas',
  'task.list.tomorrowNavAria': 'Mga gawain bukas — {{count}} kabuuan',
  'task.list.summaryCount': '{{count}} (mga) item',
  'task.list.summaryCountUnitOne': 'aytem',
  'task.list.summaryCountUnitOther': 'mga bagay',
  'task.list.editFiltersAria': 'I-edit ang mga sub-tab na gawain',
  'task.list.tabEditAllTasks': 'I-edit ang lahat ng gawain',
  'task.list.menuEditAllTasks': 'I-edit ang lahat ng gawain',
  'task.list.menuHistoryTasks': 'Kasaysayan ng nakaraang gawain',
  'task.list.menuFutureTasks': 'Mga paparating na gawain',
  'task.list.menuEditTask': 'I-edit ang gawain',
  'task.list.menuViewTask': 'Tingnan ang gawain',
  'task.list.menuReviewTask': 'Suriin ang gawain',
  'task.list.taskRowMenuAria': 'Mga aksyon para sa {{title}}',
  'task.list.titleMenuAria': 'Menu ng pamamahala ng gawain',
  'task.list.dateStripCustom': 'Custom',
  'task.list.dateStripAria': 'Pumili ng petsa',
  'task.list.customDateModalTitle': 'Pumili ng petsa',
  'task.list.timeSectionLateNight': 'Gabi na',
  'task.list.timeSectionMorning': 'Umaga',
  'task.list.timeSectionAfternoon': 'hapon',
  'task.list.timeSectionEvening': 'Gabi',
  'task.list.timeSectionNoTime': 'Walang tinukoy na oras',
  'task.list.overdueCardLabel': 'Mga overdue na gawain',
  'task.list.overdueCardView': 'Tingnan',
  'task.list.statusEffective': 'Aktibo',
  'task.list.statusNotStarted': 'Hindi nagsimula',
  'task.list.statusExpired': 'Nag-expire na',
  'employerDashboard.greetLateNight': 'Magandang gabi, {{name}}',
  'employerDashboard.greetMorning': 'Magandang umaga, {{name}}',
  'employerDashboard.greetAfternoon': 'Magandang hapon, {{name}}',
  'employerDashboard.greetEvening': 'Magandang gabi, {{name}}',
  'employerDashboard.loadError': 'Hindi ma-load ang dashboard',
  'employerDashboard.subtitle': 'Ngayon sa isang sulyap',
  'employerDashboard.todayCompletion': 'Pagkumpleto ngayong araw',
  'employerDashboard.completedFraction': '{{done}} / {{total}} tapos na',
  'employerDashboard.completedFractionValue': '{{done}} / {{total}}',
  'employerDashboard.completedFractionStatus': 'Tapos na',
  'employerDashboard.pendingTitle': 'Nakabinbing mga gawain sa pagsusuri',
  'employerDashboard.pendingEmpty': 'Walang mga pagsusumite na naghihintay ng pagsusuri',
  'employerDashboard.submittedAtLine': 'Isinumite {{at}}',
  'employerDashboard.viewAllPending': 'Tingnan ang lahat ng nakabinbin',
  'employerDashboard.monthExpenseTitle': 'Ibinigay na Pera ({{range}})',
  'employerDashboard.budgetPlaceholder': 'Wala pang aktibong Pera na Ibinigay',
  'employerDashboard.budgetTotal': 'Pera Binigay kabuuan',
  'employerDashboard.budgetUsed': 'Ginastos',
  'employerDashboard.budgetRemaining': 'Natitira',
  'employerDashboard.settlementPendingLine': '{{count}} (mga) settlement ang nangangailangan ng pansin',
  'employerDashboard.ariaTodayCompletionCard': 'Pumunta sa mga gawain — rate ng pagkumpleto ngayong araw',
  'employerDashboard.ariaOverdueCard': 'Pumunta sa mga gawain — overdue na tab',
  'employerDashboard.gettingStarted.title': 'Magsimula',
  'employerDashboard.gettingStarted.subtitle':
    'Nakapares ka na sa Helper. Tapusin ang mga setup na ito para makapagtrabaho at makapag-ulat sila sa app.',
  'employerDashboard.gettingStarted.progress': 'Nakumpleto {{done}} / {{total}}',
  'employerDashboard.gettingStarted.done': 'Tapos na',
  'employerDashboard.gettingStarted.stepCta': 'I-setup',
  'employerDashboard.gettingStarted.later': 'Mamaya na',
  'employerDashboard.gettingStarted.laterAria': 'Isara muna ang gabay sa pagsisimula',
  'employerDashboard.gettingStarted.dismissAria': 'Isara ang gabay sa pagsisimula',
  'employerDashboard.gettingStarted.dismissError': 'Hindi maisara ang gabay sa pagsisimula',
  'employerDashboard.gettingStarted.dismissToast':
    'Isinara ang gabay sa pagsisimula. I-tap ang “?” sa tabi ng pagbati para makita ulit.',
  'employerDashboard.gettingStarted.helpTriggerAria': 'Tingnan ang gabay sa pagsisimula',
  'employerDashboard.gettingStarted.regionAria': 'Gabay sa pagsisimula',
  'employerDashboard.gettingStarted.stepTaskTitle': 'Gumawa ng unang gawain',
  'employerDashboard.gettingStarted.stepTaskHint': 'Halimbawa: paglilinis, pamimili, o araw-araw na gawain',
  'employerDashboard.gettingStarted.stepTaskAria': 'Pumunta sa mga gawain para gumawa ng unang gawain',
  'employerDashboard.gettingStarted.stepBudgetTitle': 'I-set ang Money Given',
  'employerDashboard.gettingStarted.stepBudgetHint':
    'Itala ang panahon at halaga ng pera sa bahay para sa Helper',
  'employerDashboard.gettingStarted.stepBudgetAria': 'Pumunta sa magdagdag ng Money Given',
  'employerDashboard.gettingStarted.stepFamilyTitle': 'Magdagdag ng miyembro ng pamilya',
  'employerDashboard.gettingStarted.stepFamilyHint': 'Tulungan ang Helper na makilala ang pamilya',
  'employerDashboard.gettingStarted.stepFamilyAria': 'Pumunta sa mga miyembro ng pamilya',
  'employerDashboard.gettingStarted.stepPinTitle': 'Magsulat ng pin message',
  'employerDashboard.gettingStarted.stepPinHint': 'Makikita ng Helper ang paalala sa kanilang home',
  'employerDashboard.gettingStarted.stepPinAria': 'Pumunta sa gumawa ng pin message',
  'helperHome.greetLateNight': 'Magandang gabi, {{name}}',
  'helperHome.greetMorning': 'Magandang umaga, {{name}}',
  'helperHome.greetAfternoon': 'Magandang hapon, {{name}}',
  'helperHome.greetEvening': 'Magandang gabi, {{name}}',
  'pinMessage.list.title': 'I-pin ang mga setting ng mensahe',
  'pinMessage.list.subtitle': 'Ang home ticker ay sumusunod sa utos na ito. Max na {{maxItems}} na mga item.',
  'pinMessage.list.savingOrder': 'Sine-save ang order...',
  'pinMessage.list.empty': 'Wala pang pin message.',
  'pinMessage.form.addTitle': 'Magdagdag ng pin message',
  'pinMessage.form.editTitle': 'I-edit ang pin message',
  'pinMessage.form.limitLine': 'Kasalukuyang limitasyon sa antas: pamagat {{titleMax}}, nilalaman {{contentMax}}.',
  'pinMessage.form.saving': 'Sine-save...',
  'pinMessage.field.title': 'Pamagat',
  'pinMessage.field.titlePlaceholder': 'Halimbawa: Sale sa supermarket bukas, tandaan na bumili ng toyo',
  'pinMessage.field.content': 'Nilalaman',
  'pinMessage.field.contentPlaceholder': 'Detalyadong naka-pin na mensahe...',
  'pinMessage.field.visibility': 'Visibility',
  'pinMessage.field.icon': 'Icon',
  'pinMessage.field.displayFrom': 'Ipakita mula sa',
  'pinMessage.field.displayTo': 'Ipakita sa',
  'pinMessage.field.status': 'Katayuan',
  'pinMessage.status.active': 'Aktibo',
  'pinMessage.status.inactive': 'Hindi aktibo',
  'pinMessage.visibility.both': 'Employer + Katulong',
  'pinMessage.visibility.employerOnly': 'Employer lang',
  'pinMessage.icon.info': 'Impormasyon',
  'pinMessage.icon.remind': 'Paalalahanan',
  'pinMessage.icon.specialAlert': 'Espesyal na alerto',
  'pinMessage.window.always': 'Laging nakikita',
  'pinMessage.window.range': '{{from}} hanggang {{to}}',
  'pinMessage.window.from': 'Mula sa {{from}}',
  'pinMessage.window.to': 'Hanggang {{to}}',
  'pinMessage.action.add': 'Magdagdag ng pin message',
  'pinMessage.action.edit': 'I-edit',
  'pinMessage.action.remove': 'Alisin',
  'pinMessage.action.save': 'I-save',
  'pinMessage.action.cancel': 'Kanselahin',
  'pinMessage.action.close': 'Isara',
  'pinMessage.detail.createdAt': 'Nilikha sa: {{value}}',
  'pinMessage.detail.updatedAt': 'Huling binago: {{value}}',
  'pinMessage.action.moveUp': 'Umakyat',
  'pinMessage.action.moveDown': 'Ilipat pababa',
  'pinMessage.confirm.remove': 'Alisin ang pin message na ito?',
  'pinMessage.error.loadList': 'Nabigong i-load ang mga pin message',
  'pinMessage.error.saveOrder': 'Nabigong i-save ang order',
  'pinMessage.error.remove': 'Nabigong alisin ang pin message',
  'pinMessage.error.notFound': 'Hindi nakita ang mensahe ng pin',
  'pinMessage.error.loadForm': 'Nabigong i-load ang form',
  'pinMessage.error.titleContentRequired': 'Kinakailangan ang pamagat at nilalaman',
  'pinMessage.error.titleMax': 'Ang pamagat ay hindi maaaring lumampas sa {{max}} na mga character',
  'pinMessage.error.contentMax': 'Ang nilalaman ay hindi maaaring lumampas sa {{max}} na mga character',
  'pinMessage.error.dateOrder': 'Ang display mula sa petsa ay dapat na bago ipakita hanggang sa petsa',
  'pinMessage.error.save': 'Nabigong i-save ang pin message',
  'pinMessage.ticker.openDetails': 'Buksan ang mga detalye ng mensahe ng pin',
  'pinMessage.ticker.prev': 'Nakaraang pin message',
  'pinMessage.ticker.next': 'Susunod na pin message',
  'pinMessage.ticker.title': 'Pin Message',
  'pinMessage.ticker.count': '{{current}}/{{total}}',
  'helperHome.loadError': 'Hindi makapag-load sa bahay',
  'helperHome.summaryLine': '{{count}} (mga) gawain ngayon · {{budget}} na lang',
  'helperHome.dataPlaceholder': '—',
  'helperHome.cardTodayTasks': 'Mga Natitirang Gawain Ngayon',
  'helperHome.todayCompletion': 'Pagkumpleto ngayong araw',
  'helperHome.submittedFraction': '{{done}} / {{total}}',
  'helperHome.submittedFractionValue': '{{done}} / {{total}}',
  'helperHome.submittedFractionStatus': 'Naisumite',
  'helperHome.todayTaskBreakdown': 'Kabuuan: {{total}} · Tapos na: {{done}}',
  'helperHome.cardOverdueTasks': 'Mga overdue na gawain',
  'helperHome.overdueTasksHint': 'Ang mga gawain ay hindi natapos nang lampas sa takdang oras',
  'helperHome.weeklyBudgetTitle': 'Natanggap na Pera ({{range}})',
  'helperHome.detailsLabel': 'Mga Detalye',
  'helperHome.remainingLabel': 'Manatili',
  'helperHome.totalLabel': 'Kabuuan',
  'helperHome.doneLabel': 'Tapos na',
  'helperHome.budgetSpentOverTotal': 'Ginastos / Natanggap na Pera',
  'helperHome.budgetSpentLabel': 'Ginastos',
  'helperHome.budgetReceivedLabel': 'Natanggap',
  'helperHome.budgetRemainingLabel': 'Natitira',
  'helperHome.budgetOverspentLabel': 'Sobrang nagastos',
  'helperHome.balanceBadge': '{{amount}} ang natitira',
  'helperHome.overspentBadge': 'Sobrang nagastos ng {{amount}}',
  'helperHome.weeklyBudgetPlaceholder': 'Wala pang data na Natanggap na Pera',
  'helperHome.budgetUsedFootnote': 'Ginastos {{used}}',
  'helperHome.actionScanReceipt': 'I-scan ang resibo',
  'helperHome.actionScanReceiptSub': 'AI extract at isumite',
  'helperHome.tomorrowBadge': '{{count}}',
  'helperHome.actionTomorrow': 'Mga gawain bukas',
  'helperHome.actionTomorrowSub': 'Silipin ang listahan bukas',
  'helperHome.actionReceiptList': 'Listahan ng resibo',
  'helperHome.actionReceiptListSub': 'Tingnan at subaybayan',
  'helperHome.settlementReadyBadge': 'Mag-ayos',
  'helperHome.actionSettlement': 'Sumang-ayon at Makipag-ayos',
  'helperHome.actionViewDetails': 'Tingnan ang mga detalye',
  'helperHome.actionSettlementSub': 'Paggastos at mga panahon',
  'helperHome.todayPreviewTitle': 'Preview ngayong araw',
  'helperHome.suggestedTime': 'Deadline',
  'helperHome.viewAllTasks': 'Tingnan ang lahat ng mga gawain',
  'helperHome.ariaTodayTasksCard': 'Pumunta sa tab na Mga Gawain page Ngayon',
  'helperHome.ariaTodayCompletionCard': 'Pumunta sa mga gawain — rate ng pagkumpleto ngayong araw',
  'helperHome.ariaOverdueTasksCard': 'Pumunta sa tab na Overdue na pahina ng Mga Gawain',
  'helperHome.ariaMoneyReceivedCard': 'Buksan ang mga gastos at mga detalye ng settlement',
  'task.pendingReview.title': 'Nakabinbing mga gawain sa pagsusuri',
  'task.pendingReview.subtitle': 'Ang iyong katulong ay nagsumite ng mga ito — mangyaring suriin',
  'task.pendingReview.empty': 'Walang mga pagsusumite na naghihintay ng pagsusuri',
  'task.pendingReview.backToTasks': 'Bumalik sa pamamahala ng gawain',
  'task.pendingReview.dueDate': 'takdang petsa',
  'task.pendingReview.submittedAt': 'Naisumite sa',
  'task.pendingReview.submittedAtTime': 'Naisumite: {{time}}',
  'task.pendingReview.review': 'Balik-aral',
  'task.pendingReview.reviewCta': 'Pagsusuri: {{title}}',
  'task.pendingReview.loadError': 'Nabigong i-load ang mga nakabinbing review',
  'task.approvedList.title': 'Naaprubahan',
  'task.approvedList.subtitle': 'Mga pagsusumite na iyong naaprubahan',
  'task.approvedList.empty': 'Wala pang naaprubahang pagsusumite',
  'task.approvedList.backToTasks': 'Bumalik sa pamamahala ng gawain',
  'task.approvedList.dueDate': 'takdang petsa',
  'task.approvedList.submittedAt': 'Naisumite sa',
  'task.approvedList.reviewedAt': 'Naaprubahan sa',
  'task.approvedList.view': 'Tingnan ang mga detalye',
  'task.approvedList.viewCta': 'Tingnan: {{title}}',
  'task.approvedList.loadError': 'Nabigong i-load ang naaprubahang listahan',
  'task.form.createTitle': 'Lumikha ng Gawain',
  'task.form.editTitle': 'I-edit ang Gawain',
  'task.form.titleLabel': 'Pamagat ng Gawain',
  'task.form.titlePlaceholder': 'hal., Malinis na sala',
  'task.form.descLabel': 'Paglalarawan',
  'task.form.descLabelOptional': 'Paglalarawan (opsyonal)',
  'task.form.descPlaceholder': 'Ilarawan nang detalyado ang gawain...',
  'task.form.recurrenceLabel': 'Pag-ulit',
  'task.form.daysLabel': 'Mga araw',
  'task.form.daysHint': 'Pumili ng mga araw para sa lingguhan/biweekly na mga gawain',
  'task.form.recurrenceWeekdaysRequired': 'Pumili ng hindi bababa sa isang araw para sa lingguhan o dalawang linggong gawain',
  'task.form.occurrenceDateLabel': 'Petsa ng pangyayari',
  'task.form.startDateLabel': 'Petsa ng pagsisimula',
  'task.form.endDateLabel': 'Petsa ng pagtatapos',
  'task.form.endDateLabelOptional': 'Petsa ng pagtatapos (opsyonal)',
  'task.form.excludeRangesLabel': 'Ibinukod ang mga hanay ng petsa',
  'task.form.addExcludeRange': 'Magdagdag ng saklaw ng pagbubukod',
  'task.form.removeExcludeRange': 'Alisin',
  'task.form.excludeStartDateLabel': 'Ibukod ang petsa ng pagsisimula',
  'task.form.excludeEndDateLabel': 'Ibukod ang petsa ng pagtatapos',
  'task.form.dueTimeLabel': 'Takdang Panahon',
  'task.form.dueTimeLabelOptional': 'Takdang Oras (opsyonal)',
  'task.form.dueTimePlaceholder': 'hal., 18:00',
  'task.form.requirePhotoLabel': 'Mangailangan ng pagsusumite ng larawan',
  'task.form.notifyLabel': 'Abisuhan ako kapag nakumpleto na',
  'task.form.submit': 'I-save ang Gawain',
  'task.form.submitting': 'Nagse-save...',
  'task.form.createSuccess': 'Matagumpay na nagawa ang gawain',
  'task.form.updateSuccess': 'Matagumpay na na-update ang gawain',
  'task.form.createError': 'Nabigong gumawa ng gawain',
  'task.form.updateError': 'Nabigong i-update ang gawain',
  'task.form.cancel': 'Kanselahin',
  'task.review.title': 'Balik-aral na Gawain',
  'task.review.stockTakeDetailTitle': 'Detalye ng Home Stock',
  'task.review.inventoryTaskSummaryTitle': 'Buod ng Gawain ng Home Stock',
  'task.review.latestHomeStockTitle': 'Pinakabagong Home Stock',
  'task.review.latestHomeStockOpenRecentAria': 'Buksan ang kamakailang mga pagsusumite ng Home Stock',
  'task.review.latestHomeStockRecentTitle': 'Mga kamakailang isinumite',
  'task.review.latestHomeStockTaskDate': 'Petsa ng gawain',
  'task.review.latestHomeStockSubmittedAt': 'Naisumite sa',
  'task.review.latestHomeStockStatus': 'Katayuan',
  'task.review.latestHomeStockEmptyEmployer': 'Wala pang Home Stock na isinumite ng iyong katulong.',
  'task.review.latestHomeStockEmptyHelper': 'Wala pang tala ng Home Stock.',
  'task.review.addHomeStockTaskFab': 'Magdagdag ng Home Stock Task',
  'task.review.addHomeStockTaskFabAria': 'Magdagdag ng gawain sa Home Stock',
  'task.review.stocktakePhotosHeading': 'Home Stock mga larawan',
  'task.review.stocktakeResultsHeading': 'Mga resulta ng Home Stock',
  'task.review.stockLevelLegendButton': 'Alamat',
  'task.review.stockLevelLegendButtonAria': 'Ipakita ang alamat ng icon ng antas ng stock',
  'task.review.stockLevelLegendPanelAria': 'Legend ng icon ng antas ng stock',
  'task.review.stockLevelLegend.full': 'Puno',
  'task.review.stockLevelLegend.half': 'kalahati',
  'task.review.stockLevelLegend.low': 'Mababa',
  'task.review.stockLevelLegend.empty': 'Walang laman',
  'task.review.inventoryPhotosHeading': 'Larawan ng stock sa bahay',
  'task.review.inventoryLocationSummaryTitle': 'Buod ng pagsusuri sa Home Stock ayon sa lokasyon',
  'task.review.inventoryLocationSummaryLoading': 'Nilo-load ang buod...',
  'task.review.inventoryLocationSummaryCounts': '{{itemCount}} item · {{photoCount}} mga larawan',
  'task.review.inventoryLocationSummaryWithItems': 'Mga kategorya na may mga item',
  'task.review.inventoryLocationSummaryNoItems': 'Ang mga kategorya ay minarkahan ng walang item',
  'task.review.inventoryLocationSummaryNone': 'wala',
  'task.review.inventoryLocationSummaryEmpty': 'Wala pang buod ng lokasyon.',
  'task.review.helperSubmitHomeStock': 'Isumite ang Home Stock',
  'task.review.helperResubmitHomeStock': 'Muling isumite ang Home Stock',
  'task.review.inventoryLineAwaiting': 'Naghihintay ng detalye ng linya',
  'task.review.inventoryLinePendingBody': 'Ang antas ng stock at larawan ay lilitaw pagkatapos isumite ng katulong.',
  'task.review.inventorySharedPhotoNote': 'Parehong larawan sa isang item sa itaas.',
  'task.review.inventoryStatLocationsCaption': 'MGA LOKASYON',
  'task.review.inventoryStatTotalPhotosCaption': 'MGA LITRATO',
  'task.review.inventoryStatLowStockCaption': 'MABABANG STOCK',
  'task.review.inventoryStatExpiringCaption': 'MAG-EXPIRE NA',
  'task.review.inventoryFilterCategoriesHeading': 'I-filter ang mga kategorya',
  'task.review.inventoryLocationPhotosEmpty': 'Wala pang mga larawan para sa lokasyong ito.',
  'task.review.inventoryItemsFilteredEmpty': 'Walang mga item na tumutugma sa kasalukuyang mga filter ng kategorya.',
  'task.review.inventoryNoCategoriesInLocation': 'Walang mga kategoryang i-filter para sa lokasyong ito.',
  'task.review.inventoryToggleCategoryAria': 'Kategorya ng filter: {{category}}',
  'task.review.inventoryCategoryEmptyAtLocationBody': 'Walang mga item ang binilang para sa kategoryang ito sa lokasyong ito.',
  'task.review.inventoryExpiryExpired': 'Nag-expire na',
  'task.review.inventoryExpiryToday': 'Mag-e-expire ngayong araw',
  'task.review.inventoryExpiryTomorrow': 'Mag-e-expire bukas',
  'task.review.inventoryExpiryInDays': 'Mag-e-expire sa loob ng {{count}} na araw',
  'task.review.inventoryExpiryAbsolute': '{{date}} expiration',
  'task.review.inventoryLocationTabsAria': 'Piliin ang lokasyon ng imbentaryo',
  'task.review.inventoryLocationsSectionHeading': 'Lokasyon',
  'task.review.inventoryLocationsFilterReminder': 'Pumili ng tab ng lokasyon sa ibaba upang i-filter ang mga larawan at item para sa lugar na iyon.',
  'task.review.inventoryLocationsCoachmarkDismissAria': 'Isara ang tip sa lokasyon',
  'task.review.detailTitle': 'Mga detalye ng gawain',
  'task.review.helperAwaitingEmployerBanner': 'Naisumite na ang gawaing ito at naghihintay na suriin ito ng iyong tagapag-empleyo.',
  'task.review.futureDueDetailOnly': 'Ang gawaing ito ay hindi pa maaaring isumite. Maaari mo lamang tingnan ang mga detalye dito.',
  'task.review.futureDueOutOfRange': 'Ang gawaing ito ay nasa labas ng window ng maagang pagsumite. Maaari mo lamang tingnan ang mga detalye dito.',
  'task.review.futureDueEmployerTomorrow': 'Ang gawaing ito ay naka-iskedyul para bukas.',
  'task.review.futureDueEmployerDays': 'Ang gawaing ito ay nakaiskedyul {{days}} araw mula ngayon.',
  'task.review.futureDueHelperTomorrow': 'Ang gawaing ito ay naka-iskedyul para bukas. Pakitandaan ang petsa ng gawain!',
  'task.review.futureDueHelperDays': 'Ang gawaing ito ay nakaiskedyul {{days}} araw mula ngayon. Pakitandaan ang petsa ng gawain!',
  'task.todo.futureSubmitBanner': 'Maaari kang magsumite ng mga paparating na gawain nang maaga',
  'task.todo.tabFuture': 'kinabukasan',
  'task.todo.helperEmptyFuture': 'Walang mga gawain sa hanay ng petsa na ito',
  'task.todo.helperEmptyFutureHint': 'Subukan ang ibang hanay o suriin sa iyong employer.',
  'task.submitConfirmTitle': 'Isumite ang gawaing ito?',
  'task.submitConfirmPrompt': 'Ang petsa ng gawain ay ipinapakita sa ibaba. Kumpirmahin ang pagsusumite?',
  'task.submitConfirmAction': 'Kumpirmahin ang pagsusumite',
  'task.submitConfirm.dueDateTomorrow': '{{date}} (Bukas)',
  'task.submitConfirm.dueDateDaysLater': '{{date}} (sa {{days}} na araw)',
  'task.review.taskInfo': 'Impormasyon sa Gawain',
  'task.review.submittedBy': 'Ipinasa ni',
  'task.review.taskDate': 'Petsa ng gawain',
  'task.review.completedAt': 'Nakumpleto noong',
  'task.review.submittedAt': 'Naisumite sa',
  'task.review.photos': 'Mga larawan',
  'task.review.prevPhoto': 'Naunang larawan',
  'task.review.nextPhoto': 'Susunod na larawan',
  'task.review.photoCount': '{{current}} / {{total}}',
  'task.review.gpsLocation': 'Lokasyon ng GPS',
  'task.review.gpsDisabled': 'Hindi pinagana ang GPS',
  'task.review.gpsStaticMapAlt': 'Isinumite na lokasyon ng gawain (preview ng mapa)',
  'task.review.openInGoogleMaps': 'Buksan sa Google Maps',
  'task.review.openInGoogleMapsAria': 'Buksan ang lokasyong ito sa Google Maps sa isang bagong tab',
  'task.review.osmCopyright': '© Mga kontribyutor ng OpenStreetMap',
  'task.review.addressLabel': 'Address',
  'task.review.addressLoading': 'Hinahanap ang address…',
  'task.review.addressUnavailable': 'Walang available na text ng address para sa lokasyong ito',
  'task.review.note': 'Tandaan',
  'task.review.noNote': 'Walang note',
  'task.review.reviewPrompt': 'Mangyaring suriin ↓',
  'task.review.approve': 'Aprubahan',
  'task.review.reject': 'Tanggihan',
  'task.review.needsUpdate': 'Kailangan ng Update',
  'task.review.needsUpdateModalTitle': 'Kailangan ng update',
  'task.review.needsUpdateReasonPrompt': 'Ilagay kung bakit kailangan ng mga pagbabago ang pagsusumiteng ito.',
  'task.review.needsUpdateReasonTooShort': 'Masyadong maikli ang dahilan. Pinakamababang {{min}} (na) character.',
  'task.review.needsUpdatePhotoHint': 'Maaaring alisin ng helper ang mga maling larawan at mag-upload ng mga tama kapag muling nagsumite.',
  'task.review.reviewSuccess': 'Naisumite ang pagsusuri',
  'task.review.reviewError': 'Nabigo ang pagsusuri',
  'task.review.versionConflict': 'Ang data ay nabago, mangyaring i-reload',
  'task.review.loadError': 'Nabigong i-load ang mga detalye ng gawain',
  'comment.sectionTitle': 'Mga komento',
  'comment.usage': '{{used}} / {{max}} na mga komentong ginamit',
  'comment.charCount': '{{current}} / {{max}} na mga character',
  'comment.placeholder': 'Sumulat ng komento…',
  'comment.writeButton': 'Sumulat ng komento',
  'comment.modalTitle': 'Sumulat ng komento',
  'comment.draftPending': 'Draft',
  'comment.send': 'Ipadala',
  'comment.sending': 'Ipinapadala…',
  'comment.loadError': 'Nabigong i-load ang mga komento',
  'comment.sendError': 'Nabigong magpadala ng komento',
  'comment.empty': 'Wala pang komento',
  'comment.limitReached': 'Naabot na ang limitasyon sa komento para sa item na ito.',
  'comment.sendAria': 'Magpadala ng komento',
  'comment.listAria': 'Listahan ng komento',
  'comment.emptyDraft': 'Mangyaring maglagay ng komento',
  'comment.tooLong': 'Ang komento ay hindi dapat lumampas sa {{max}} na mga character',
  'comment.shortcutHint': 'Pindutin ang Ctrl+Enter o Cmd+Enter para ipadala',
  'comment.unsentSubmit.title': 'Hindi naipadala ang komento',
  'comment.unsentSubmit.descriptionTask': 'Nag-type ka ng komento ngunit hindi pinindot ang Ipadala. Isumite ang gawain at i-post ang komentong ito nang magkasama?',
  'comment.unsentSubmit.descriptionStockTake': 'Nag-type ka ng komento ngunit hindi pinindot ang Ipadala. Isumite ang Home Stock at i-post ang komentong ito nang magkasama?',
  'comment.unsentSubmit.descriptionResubmit': 'Nag-type ka ng komento ngunit hindi pinindot ang Ipadala. Muling isumite ang gawain at i-post ang komentong ito nang magkasama?',
  'comment.unsentSubmit.backToEdit': 'Bumalik sa pag-edit',
  'comment.unsentSubmit.submitOnlyTask': 'Isumite lamang ang gawain',
  'comment.unsentSubmit.submitOnlyStockTake': 'Magsumite lamang ng Home Stock',
  'comment.unsentSubmit.submitOnlyResubmit': 'Muling isumite lamang',
  'comment.unsentSubmit.submitWithComment': 'Isumite at i-post ang komento',
  'comment.unsentSubmit.working': 'Mangyaring maghintay…',
  'notification.bellAria': 'Mga abiso',
  'notification.panelTitle': 'Mga abiso',
  'notification.empty': 'Walang notification',
  'notification.markAllRead': 'Markahan ang lahat bilang nabasa na',
  'notification.markAllReadAria': 'Markahan ang lahat ng notification bilang nabasa na',
  'notification.loadError': 'Nabigong i-load ang mga notification',
  'notification.expand': 'Palawakin ▼',
  'notification.collapse': 'Tiklupin ▲',
  'notification.expandAria': 'Palawakin ang buong teksto ng notification',
  'notification.collapseAria': 'Tiklupin ang teksto ng notification',
  'task.today.title': 'Listahan ng mga gawain',
  'task.today.subtitle': 'Mag-browse ng mga gawain ayon sa kasaysayan, overdue, ngayon, at hinaharap',
  'task.today.empty': 'Walang gawain para sa araw na ito',
  'task.today.emptyHint': 'Magpahinga ka na!',
  'task.todo.helperEmptyOverdue': 'Walang overdue na gawain sa ngayon',
  'task.todo.helperEmptyOverdueHint': 'Patuloy na kumpletuhin ang mga gawain bago ang kanilang mga deadline.',
  'task.todo.helperEmptyTomorrow': 'Wala pang nakaiskedyul para bukas',
  'task.todo.helperEmptyTomorrowHint': 'Bumalik sa ibang pagkakataon o tanungin ang iyong employer kung may idinagdag.',
  'task.today.complete': 'Kumpleto',
  'task.today.view': 'Tingnan',
  'task.today.pendingReview': '{{count}} mga gawain na nakabinbing pagsusuri ng iyong tagapag-empleyo',
  'task.today.sectionNotSubmitted': 'Hindi isinumite',
  'task.today.sectionNeedsUpdate': 'Kailangan ng update',
  'task.today.sectionCompleted': 'Nakumpleto',
  'task.today.employerFeedbackLabel': 'Mensahe ng employer:',
  'task.today.dueAt': 'Nakatakda sa {{time}}',
  'task.today.cannotSubmitTomorrow': 'Available bukas',
  'task.today.tomorrowSubmitBanner': 'Maaari mong isumite ang mga gawain sa ibaba simula bukas.',
  'task.todo.tabHistory': 'Kasaysayan',
  'task.todo.tabOverdue': 'Overdue na',
  'task.todo.tabToday': 'Ngayong araw',
  'task.todo.tabTomorrow': 'Bukas',
  'task.todo.deadlineToday': 'Ngayong araw',
  'task.todo.deadlineTomorrowShort': 'Tmr.',
  'task.todo.inventoryPreviewLocationsLabel': 'Mga lokasyon',
  'task.todo.inventoryPreviewCategoriesLabel': 'Mga kategorya',
  'task.todo.receiptScanBanner': 'I-scan ang mga resibo upang mabilis na mai-log ang paggastos',
  'task.history.startDate': 'Petsa ng pagsisimula',
  'task.history.endDate': 'Petsa ng pagtatapos',
  'task.history.filterAria': 'I-filter ang kasaysayan ng gawain ayon sa katayuan',
  'task.history.statusAll': 'Lahat',
  'task.history.empty': 'Walang mga gawain na tumutugma sa iyong mga filter sa hanay ng petsa na ito',
  'task.history.emptyHint': 'Isaayos ang hanay ng petsa o filter ng katayuan',
  'task.history.relativeToday': 'Ngayong araw',
  'task.history.relativeYesterday': 'Kahapon',
  'task.history.relativeTomorrow': 'Bukas',
  'task.history.dateHeadingWithRelative': '{{date}} ({{relative}})',
  'task.history.groupTotalCount': '{{count}} (mga) tala',
  'task.history.completionTime': 'Nakumpleto: {{time}}',
  'task.employerFuture.title': 'Mga paparating na gawain',
  'task.employerFuture.empty': 'Walang mga gawain sa hanay ng petsa na ito',
  'task.employerFuture.loadError': 'Nabigong i-load ang mga paparating na gawain',
  'task.employerFuture.openDetailCta': 'Tingnan ang gawain: {{title}}',
  'task.today.loadError': 'Nabigong i-load ang mga gawain',
  'receipt.analyze.navLink': 'Resibo AI',
  'receipt.analyze.title': 'Pagsusuri ng AI sa resibo',
  'receipt.analyze.subtitle': 'Pumili ng mga larawan ng resibo; awtomatikong napupunan ang mga patlang (maaari mong i-edit)',
  'receipt.analyze.pickImages': 'Mag-upload ng mga larawan ng resibo (Max. 10 larawan bawat batch)',
  'receipt.analyze.pickImagesAria': 'Pumili ng mga file ng larawan ng resibo',
  'receipt.analyze.analyzing': 'Sinusuri...',
  'receipt.analyze.analyzingProgress': 'Sinusuri ang {{current}} / {{total}}',
  'receipt.analyze.analyzeError': 'Nabigo ang pagsusuri',
  'receipt.analyze.rateLimit': 'Naabot na ang limitasyon sa pang-araw-araw na pagsusuri ng AI ({{used}} / {{limit}}). Subukang muli pagkatapos ng {{retryAt}}.',
  'receipt.analyze.manualHint': 'Nabigo ang pagsusuri — mangyaring ipasok o iwasto ang mga field nang manu-mano.',
  'receipt.analyze.fileTooLarge': 'Lampas 10MB ang file',
  'receipt.analyze.badType': 'Hindi sinusuportahang uri ng larawan',
  'receipt.analyze.tooManyFiles': 'Pinakamataas na 10 larawan',
  'receipt.analyze.field.company': 'Kumpanya / tatak',
  'receipt.analyze.field.shop': 'Tindahan / sangay',
  'receipt.analyze.field.date': 'Petsa',
  'receipt.analyze.field.currency': 'Pera',
  'receipt.analyze.field.total': 'Kabuuan',
  'receipt.analyze.field.remark': 'Puna',
  'receipt.analyze.aiRemarkLabel': 'Pahayag ng system',
  'receipt.analyze.items': 'Mga line item',
  'receipt.analyze.itemsAction': 'Aksyon',
  'receipt.analyze.itemName': 'item',
  'receipt.analyze.qty': 'Qty',
  'receipt.analyze.amount': 'Halaga',
  'receipt.analyze.addItem': 'Magdagdag ng linya',
  'receipt.analyze.removeItem': 'Alisin',
  'receipt.analyze.removeRow': 'Alisin ang resibo na ito',
  'receipt.analyze.removeConfirmTitle': 'Alisin ang resibo na ito?',
  'receipt.analyze.removeConfirmBody': 'Itatapon ang nasuri na entry na ito.',
  'receipt.analyze.leaveConfirmTitle': 'Umalis sa page na ito?',
  'receipt.analyze.leaveConfirmBody': 'Mayroon kang mga larawan ng resibo at data na hindi pa naisumite. Mawawala sila kung aalis ka.',
  'receipt.analyze.leaveConfirmLeave': 'umalis',
  'receipt.analyze.leaveConfirmStay': 'Manatili sa pahinang ito',
  'receipt.analyze.budgetLabel': 'Panahon ng Natanggap na Pera',
  'receipt.analyze.budgetRequired': 'Mangyaring pumili ng panahon ng Natanggap na Pera',
  'receipt.analyze.dateLabel': 'Petsa ng pagtanggap',
  'receipt.analyze.dateRequired': 'Mangyaring pumili ng wastong petsa ng pagtanggap',
  'receipt.analyze.companyRequired': 'Pakilagay ang kumpanya / brand',
  'receipt.analyze.submit': 'I-save',
  'receipt.analyze.submitAll': 'I-save ang Lahat ng Resibo',
  'receipt.analyze.submitting': 'Isinusumite…',
  'receipt.analyze.submittingAllProgress': 'Sine-save ang {{current}} / {{total}}',
  'receipt.analyze.submitSuccess': 'Naisumite',
  'receipt.analyze.submittedDueToPendingSettlement': 'Ang petsa ng pagtanggap na ito ay nasa loob ng isang nakabinbing panahon ng pag-aayos, kaya direkta itong minarkahan bilang "Isinusumite".',
  'receipt.analyze.submitError': 'Nabigo ang pagsumite',
  'receipt.analyze.needImageUrl': 'Nawawala ang URL ng naka-imbak na larawan — hindi maisumite (tingnan ang cloud storage)',
  'receipt.analyze.invalidTotal': 'Maglagay ng wastong kabuuang halaga',
  'receipt.analyze.totalMismatchBanner': 'Ang kabuuang ({{total}}) ay hindi tumutugma sa mga line item ({{lineSum}}). Mangyaring suriin.',
  'receipt.analyze.totalMismatchConfirmTitle': 'Hindi pagkakatugma ng halaga',
  'receipt.analyze.totalMismatchConfirmSingle': 'Ang kabuuang resibo ({{total}}) ay hindi tumutugma sa mga line item ({{lineSum}}). Mangyaring suriin. Gumagamit ang settlement ng kabuuang ({{total}}). Kumpirmahin upang i-save?',
  'receipt.analyze.totalMismatchConfirmBatchLine': '{{date}} {{company}} na resibo: kabuuang ({{total}}) ay hindi tumutugma sa mga line item ({{lineSum}}). Mangyaring suriin.',
  'receipt.analyze.totalMismatchConfirmBatchIntro': 'Ang mga sumusunod na resibo ay may kabuuang hindi tumutugma sa mga line item:',
  'receipt.analyze.totalMismatchConfirmBatchFooter': 'Ginagamit ng settlement ang kabuuang resibo. Kumpirmahin upang i-save?',
  'receipt.analyze.totalMismatchConfirmConfirm': 'Kumpirmahin ang pag-save',
  'receipt.analyze.backToday': 'Bumalik sa ngayon',
  'receipt.detail.title': 'Detalye ng resibo',
  'receipt.detail.backToList': 'Bumalik sa listahan ng resibo',
  'receipt.detail.loadError': 'Hindi ma-load ang resibo',
  'receipt.detail.total': 'Kabuuan',
  'receipt.detail.date': 'Petsa ng pagtanggap',
  'receipt.detail.submittedAt': 'Naisumite sa',
  'receipt.detail.employerReviewSubmittedAt': 'Ang pagsusuri ng employer ay isinumite sa',
  'receipt.detail.delete': 'Tanggalin ang resibo',
  'receipt.detail.deleteHint': 'Maaari ka lang magtanggal ng mga resibo na nakabinbin, nangangailangan ng update, o nakansela.',
  'receipt.detail.deleteConfirmTitle': 'Tanggalin ang resibo na ito?',
  'receipt.detail.deleteConfirmBody': 'Hindi na ito maaaring bawiin. Aalisin din ang mga komento sa resibong ito.',
  'receipt.detail.deleting': 'Tinatanggal…',
  'receipt.detail.cannotDelete': 'Hindi matatanggal ang resibong ito sa kasalukuyang katayuan nito.',
  'receipt.detail.photoHeading': 'Larawan ng resibo',
  'receipt.detail.photoAlt': 'Larawan ng resibo',
  'receipt.detail.employerSavedReceiptNotice': 'Ang petsang ito ay hindi pa nasettle, at ang resibo na ito ay hindi pormal na isinumite; pwede pa namang i-edit ng katulong.',
  'receipt.detail.helperUnsettledBanner': 'Hindi pa kasama ang resibong ito sa settlement',
  'receipt.detail.helperUnsettledBannerCta': 'Sumang-ayon at Makipag-ayos',
  'receipt.detail.helperUnsettledBannerCtaAria': 'Pumunta sa Mga gastos at settlement para magsumite',
  'receipt.detail.editReceipt': 'I-edit ang resibo',
  'receipt.detail.changeReviewStatus': 'Baguhin ang katayuan',
  'receipt.detail.changeReviewStatusAria': 'Buksan ang dialog ng pagbabago ng katayuan ng resibo',
  'receipt.detail.changeReviewStatusTitle': 'Baguhin ang status ng pagsusuri ng resibo',
  'receipt.detail.changeReviewStatusBody': 'Pakipili ang bagong status ng pagsusuri.',
  'receipt.edit.title': 'I-edit ang resibo',
  'receipt.edit.subtitle':
    'Ang mga resibong “Hindi pa nasettle” lang ang maaaring i-edit bago isumite ang settlement.',
  'receipt.edit.backToDetail': 'Bumalik sa detalye ng resibo',
  'receipt.edit.save': 'I-save ang mga pagbabago',
  'receipt.edit.saving': 'Sine-save...',
  'receipt.edit.saveError': 'Nabigo ang pag-save',
  'receipt.edit.blockedStatus':
    'Hindi maaaring i-edit ang resibo na ito. Tanging ang iyong mga resibo na “Hindi pa nasettle” ang maaaring i-edit.',
  'receipt.edit.blockedNotOwner': 'Maaari mo lamang i-edit ang mga resibo na iyong isinumite.',
  'receipt.analyze.photoHeading': 'Larawan ng resibo',
  'receipt.analyze.photoHeadingOfTotal': 'Larawan ng resibo ({{current}} ng {{total}})',
  'receipt.analyze.photoAlt': 'Larawan ng resibo',
  'receipt.analyze.enlargeImageAria': 'Tingnan ang buong laki ng larawan ng resibo',
  'receipt.analyze.openDetailAria': 'Buksan ang detalye ng resibo',
  'receipt.analyze.scanMore': 'I-scan ang higit pang resibo',
  'receipt.analyze.nextStepSheetTitle': 'Na-save ang resibo',
  'receipt.analyze.nextStepSheetLead': 'Susunod: isumite ang settlement sa employer.',
  'receipt.analyze.nextStepSheetUploadAll':
    'I-upload ang lahat ng resibo para sa settlement period sa ibaba bago mag-settle.',
  'receipt.analyze.nextStepSheetLockNote':
    'Pagkatapos isumite ang settlement, ipinapadala ang mga resibo sa period sa employer. Hindi ka na makakapag-upload o mag-edit ng resibo para sa mga petsang iyon.',
  'receipt.analyze.nextStepSheetEmployerReview':
    'Susuriin ng employer pagkatapos mo lang isumite ang settlement.',
  'receipt.analyze.nextStepSheetPeriodLabel': 'Settlement period',
  'receipt.analyze.nextStepSheetPeriodRange': '{{start}} – {{end}}',
  'receipt.analyze.nextStepSheetPeriodLoading': 'Nilo-load ang settlement period…',
  'receipt.analyze.nextStepSheetPeriodUnknown':
    'Wala pang tumutugmang Money Received period. Maaari mo pa ring buksan ang Mga gastos at settlement mamaya para pumili ng period at magsumite.',
  'receipt.analyze.nextStepSheetPeriodLocked': 'Naka-lock',
  'receipt.analyze.nextStepSheetLockedHint':
    'May aktibo o naka-lock nang settlement ang tumutugmang period. Tingnan ang detalye sa expenses page.',
  'receipt.analyze.nextStepSheetGoSettle': 'Pumunta sa settlement',
  'receipt.analyze.nextStepSheetGoSettleAria': 'Pumunta sa Mga gastos at settlement para magsumite',
  'receipt.analyze.nextStepSheetLater': 'Mamaya',
  'receipt.analyze.nextStepSheetLaterAria': 'Isara ang paalala at magsumite ng settlement mamaya',
  'receipt.list.title': 'Listahan ng resibo',
  'receipt.list.subtitle': 'Tingnan ang mga katayuan ng resibo at mga oras ng pagsusumite',
  'receipt.list.filterAria': 'I-filter ang mga resibo ayon sa katayuan',
  'receipt.list.filter.all': 'Lahat',
  'receipt.list.filter.save': 'Hindi pa nasettle',
  'receipt.list.filter.submitted': 'Isinumite para sa settlement',
  'receipt.list.filter.reviewed': 'Sinuri',
  'receipt.list.startDate': 'Petsa ng pagsisimula (opsyonal)',
  'receipt.list.endDate': 'Petsa ng pagtatapos (opsyonal)',
  'receipt.list.requiredStartDate': 'Petsa ng pagsisimula',
  'receipt.list.requiredEndDate': 'Petsa ng pagtatapos',
  'receipt.list.empty': 'Walang mga resibo na tumutugma sa mga filter na ito.',
  'receipt.list.loadError': 'Hindi ma-load ang listahan ng resibo',
  'receipt.list.loadMore': 'Mag-load pa',
  'receipt.list.openDetailAria': 'Buksan ang resibo {{date}}: {{summary}}',
  'receipt.list.submittedAtLine': 'Naisumite sa: {{at}}',
  'budget.title': 'Ibinigay ng Pera',
  'budget.subtitle': 'Itakda ang mga panahon at halaga ng pangunahing at Add-on na Pera',
  'budget.tabActive': 'Isinasagawa',
  'budget.tabSettled': 'Naayos na',
  'budget.tabsAria': 'Mga kategorya ng listahan ng Money Given',
  'budget.addNew': 'Bagong Pera na Ibinigay',
  'budget.addNewAria': 'Lumikha ng bagong Pera na Ibinigay na panahon',
  'budget.addOn': 'Idagdag',
  'budget.addOnAria': 'Add-on Money para sa panahong ito',
  'budget.form.addOnCreateTitle': 'Dagdag na Pera',
  'budget.form.parentPeriod': 'Pangunahing panahon',
  'budget.empty': 'Walang data',
  'budget.emptySettled': 'Wala pang settled Money Given periods.',
  'budget.emptyHint': 'Lumikha ng Pera na Ibinigay upang ang iyong katulong ay makapag-tag ng mga resibo at makapagpatakbo ng mga settlement.',
  'budget.filterStartDate': 'Petsa ng pagsisimula',
  'budget.filterEndDate': 'Petsa ng pagtatapos',
  'budget.totalAmount': 'Pera na ibinigay na halaga',
  'budget.mainAmountLabel': 'Ibinigay ng Pera',
  'budget.subAmountLabel': 'Dami ng add-on',
  'budget.spent': 'Ginastos',
  'budget.remaining': 'Natitira',
  'budget.badgeLocked': 'May naka-lock na settlement',
  'budget.badgeSettled': 'Naayos na',
  'budget.timeLabel': 'Oras: {{value}}',
  'budget.edit': 'I-edit',
  'budget.editAria': 'I-edit ang Pera na Ibinigay {{start}} hanggang {{end}}',
  'budget.mergedChildCount': 'Kasama ang {{count}} (mga) Add-on Money item',
  'budget.expandChildrenAria': 'Palawakin ang mga detalye ng Add-on Money para sa {{start}} hanggang {{end}}',
  'budget.collapseChildrenAria': 'I-collapse ang mga detalye ng Add-on Money para sa {{start}} hanggang {{end}}',
  'budget.backList': 'Bumalik sa listahan ng Money Given',
  'budget.loadError': 'Hindi ma-load ang Money Given',
  'budget.saveError': 'Nabigo ang pag-save',
  'budget.form.createTitle': 'Bagong Pera na Ibinigay',
  'budget.form.editTitle': 'I-edit ang Money Given period',
  'budget.form.startDate': 'Petsa ng pagsisimula',
  'budget.form.endDate': 'Petsa ng pagtatapos',
  'budget.form.amount': 'Pera na ibinigay na halaga',
  'budget.form.amountHint': 'Dapat ay zero o positibo; pinapayagan ang mga decimal.',
  'budget.form.submitCreate': 'Lumikha ng Pera na Ibinigay',
  'budget.form.submitEdit': 'I-save ang mga pagbabago',
  'budget.form.saving': 'Sine-save...',
  'budget.form.cancel': 'Kanselahin',
  'budget.form.remove': 'Alisin',
  'budget.form.removeAria': 'Alisin ang panahong Ibinigay ng Pera na ito',
  'budget.form.removeConfirm': 'Alisin',
  'budget.form.removing': 'Tinatanggal…',
  'budget.removeConfirmTitle': 'Alisin itong Pera na Ibinigay?',
  'budget.removeConfirmBody': 'Alisin itong Money Given period? Hindi na ito maaaring bawiin.',
  'budget.removeConfirmReceiptsExtra': '{{count}} (mga) resibo ay naka-link sa panahong Ibinigay ng Pera na ito; ang pag-alis nito ay nililinis ang link na iyon.',
  'budget.removeError': 'Hindi maalis ang Money Given',
  'budget.validation.rangeRequired': 'Pakilagay ang mga petsa ng pagsisimula at pagtatapos',
  'budget.validation.dates': 'Ang petsa ng pagtatapos ay hindi maaaring bago ang petsa ng pagsisimula',
  'budget.validation.amount': 'Maglagay ng wastong halaga (zero o positibo)',
  'budget.lockedEditHint': 'Ang Ibinigay na Pera na ito ay nakatali sa isang naka-lock na kasunduan. Kung paikliin mo ang hanay ng petsa, ang bawat naka-link na resibo ay dapat pa ring ganap na nasa loob ng bagong hanay. Mabibigo ang pag-save kung ang anumang petsa ng pagtanggap ay nasa labas ng bagong hanay o magkakapatong sa isa pang panahon ng pag-aayos; lutasin muna ang mga resibo o settlement kung kinakailangan.',
  'budget.summaryReceipts': 'Ang Ibinigay na Pera na ito ay may {{count}} na (mga) naka-link na resibo',
  'settlement.title': 'Settlement at pagsasara',
  'settlement.employerFinanceTitle': 'Pera na Ibinigay at Settlement',
  'settlement.employerFinanceTitleMenuAria': 'Menu ng Money Given & Settlement',
  'settlement.employerFinanceMenuPendingReviewList': 'Mga settlement na nakabinbing pagsusuri',
  'settlement.employerFinanceMenuReceiptList': 'Listahan ng resibo',
  'settlement.formTitle': 'Bagong paninirahan',
  'settlement.subtitle': 'Pumili ng tuldok. Kasama sa mga kabuuan ang lahat ng mga resibo sa hanay kumpara sa katugmang halaga ng Natanggap na Pera. Ang pag-lock ay nag-freeze ng mga resibo sa hanay na iyon.',
  'settlement.navLink': 'Settlement ng gastos',
  'settlement.budgetLabel': 'Panahon ng Natanggap na Pera',
  'settlement.startDate': 'Petsa ng pagsisimula',
  'settlement.endDate': 'Petsa ng pagtatapos',
  'settlement.preview': 'I-preview ang mga kabuuan',
  'settlement.previewing': 'Kinakalkula…',
  'settlement.totalSpent': 'Kabuuang Ginastos',
  'settlement.dailyDetail': 'Pagkasira',
  'settlement.dailyDetailOpen': 'Buksan ang pang-araw-araw na breakdown ng gastos',
  'settlement.dailyDetailTitle': 'Pang-araw-araw na breakdown ng gastos',
  'settlement.dailyDetailDate': 'Petsa',
  'settlement.dailyDetailReceiptCount': 'Bilang ng resibo',
  'settlement.dailyDetailAmount': 'Halaga',
  'settlement.budgetAmount': 'Ibinigay ng Pera',
  'settlement.submittedAtLabel': 'Naisumite sa',
  'settlement.balance': 'Resulta ng Settlement',
  'settlement.surplus': 'Sobra',
  'settlement.overspent': 'Sobrang nagastos',
  'settlement.confirm': 'Kumpirmahin ang settlement at lock',
  'settlement.confirming': 'Pinoproseso…',
  'settlement.success': 'Naka-lock ang settlement',
  'settlement.error': 'Nagkaproblema',
  'settlement.listTitle': 'Kasaysayan ng paninirahan',
  'settlement.employerFinanceTabsAria': 'Employer Money Given at mga tab ng settlement',
  'settlement.employerTabBudget': 'Ibinigay ng Pera',
  'settlement.employerTabSettlement': 'Settlement',
  'settlement.employerSubTabReceipts': 'Listahan ng resibo',
  'settlement.filterStartDate': 'Petsa ng pagsisimula',
  'settlement.filterEndDate': 'Petsa ng pagtatapos',
  'settlement.employerFilterToDateOptional': 'Petsa ng pagtatapos (opsyonal)',
  'settlement.empty': 'Wala pang settlements',
  'settlement.locked': 'Sinuri',
  'settlement.unlocked': 'Na-unlock',
  'settlement.status.submitted': 'Nakabinbing pagsusuri',
  'settlement.status.unsettled': 'Hindi maayos',
  'settlement.status.settled': 'Naayos na',
  'settlement.unsettledEmployerSavedReceiptNotice': 'Ang iyong katulong ay hindi nagsumite ng isang kasunduan para sa petsang ito, at ang resibo ay hindi pa opisyal na naisumite. Maaari pa ring baguhin ng iyong katulong ang nilalaman ng resibo.',
  'settlement.givenVsExpensesTitle': 'Ibinigay ng Pera kumpara sa Mga Gastos',
  'settlement.givenVsExpensesSubtitle': 'Pangkalahatang-ideya ng huling 4 na panahon na Ibinigay ng Pera',
  'settlement.givenVsExpensesGiven': 'Ibinigay',
  'settlement.givenVsExpensesSpent': 'Ginastos',
  'settlement.givenVsExpensesPendingSpent': 'Nakabinbing nagastos',
  'settlement.helperReceivedVsExpensesTitle': 'Pera na Natanggap kumpara sa Mga Gastos',
  'settlement.helperReceivedVsExpensesSubtitle': 'Pangkalahatang-ideya ng huling 4 na panahon ng Natanggap na Pera',
  'settlement.reviewNow': 'Suriin ngayon',
  'settlement.pendingReviewPageTitle': 'Mga settlement na nakabinbing pagsusuri',
  'settlement.historyEventAtLabel': 'Oras ng katayuan',
  'settlement.historyViewDetailAria': 'Tingnan ang mga detalye ng history ng settlement',
  'settlement.historyDetailButton': 'Detalye',
  'settlement.pastSettlementHistoryTitle': 'Kasaysayan ng nakaraang paninirahan',
  'settlement.historyStatus.withdrawn': 'Inalis ang katulong',
  'settlement.historyStatus.rejected': 'Tinanggihan ng employer',
  'settlement.historyStatus.unlocked': 'Na-unlock ang employer',
  'settlement.status.reviewed': 'Sinuri',
  'settlement.status.rejected': 'Tinanggihan',
  'settlement.status.withdrawn': 'Binawi',
  'settlement.recordStatusFilterAria': 'I-filter ang mga settlement ayon sa status',
  'settlement.recordStatusFilter.submitted': 'Nakabinbin',
  'settlement.recordStatusFilter.reviewed': 'Sinuri',
  'settlement.recordStatusFilter.rejected': 'Tinanggihan',
  'settlement.recordStatusFilter.withdrawn': 'Binawi',
  'settlement.recordStatusFilter.unlocked': 'Na-unlock',
  'settlement.lockHint': 'Naayos na at naka-lock na ang paggastos para sa mga petsang ito. Hilingin sa iyong employer na i-unlock ang settlement na iyon sa app bago ka makapag-edit o magtanggal ng mga resibo sa panahong ito.',
  'settlement.detailTitle': 'Detalye ng settlement',
  'settlement.detailTitleMenuAria': 'Menu ng detalye ng settlement',
  'settlement.menuEditMoneyGiven': 'I-edit ang ibinigay na pera',
  'settlement.menuAppendMoneyGiven': 'Magdagdag ng perang ibinigay',
  'settlement.unlock': 'I-unlock ang settlement',
  'settlement.withdraw': 'Bawiin ang pagsusumite ng kasunduan',
  'settlement.reviewedAction': 'Markahan bilang nasuri',
  'settlement.rejectReasonPrompt': 'Pakilagay ang dahilan ng pagtanggi',
  'settlement.rejectModalTitle': 'Tanggihan ang kasunduan na ito',
  'settlement.unlockConfirmTitle': 'I-unlock ang settlement?',
  'settlement.unlockConfirmBody': 'Pagkatapos ng pag-unlock, maaaring i-edit ng helper ang mga resibo sa hanay ng petsang ito. Ang aksyon na ito ay naitala sa audit log.',
  'settlement.unlocking': 'Ina-unlock…',
  'settlement.unlockSuccess': 'Na-unlock',
  'settlement.auditTitle': 'I-unlock ang kasaysayan',
  'settlement.auditEmpty': 'Wala pang mga kaganapan sa pag-unlock',
  'settlement.receiptsTitle': 'Nasa hanay ang mga resibo',
  'settlement.viewReceipt': 'Tingnan ang resibo',
  'settlement.noBudgets': 'Maaari kang mag-upload ng mga resibo at manirahan nang hindi muna nagse-set up ng Money Given; kung walang umiiral na panahon ng pagtutugma, ang kabuuang Pera na Natanggap ay ituturing bilang 0.',
  'settlement.employerNoBudgetsBanner': 'Wala pang Money Given periods. Gumagana pa rin ang mga settlement; isaalang-alang ang pagdaragdag ng Money Given para sa kalinawan.',
  'settlement.selectRange': 'Mangyaring pumili ng mga petsa ng pagsisimula at pagtatapos',
  'settlement.confirmLockModalTitle': 'Isumite ang settlement na ito sa employer?',
  'settlement.confirmEmptyModalTitle': 'Walang mga resibo sa hanay na ito',
  'settlement.confirmLockPrompt': 'Kumpirmahin na isumite ang {{start}} - {{end}} settlement? Ang mga resibo sa hanay ay hindi maaaring i-edit at i-upload.',
  'settlement.confirmEmptyReceiptsPrompt': 'Walang mga resibo sa hanay na ito. Isumite pa rin?',
  'settlement.previewFirst': 'Hindi pa handa ang preview. Hintaying mag-load o ayusin ang mga kabuuan ng mga petsa bago i-lock.',
  'settlement.budgetAmountHint': 'Kabuuan ng pangunahing panahon at lahat ng halaga ng Add-on Money.',
  'settlement.helperHeroTitle': 'Mga gastos at settlement',
  'settlement.helperHeroSubtitle': 'Pamahalaan ang iyong mga gastos at isumite sa iyong employer.',
  'settlement.helpPopoverTriggerAria': 'Tingnan ang mga hakbang at paalala sa settlement',
  'settlement.helpPopoverAria': 'Mga hakbang at paalala sa settlement',
  'settlement.helpPopoverTitle': 'Paano magsumite ng settlement',
  'settlement.helpPopoverStep1': 'I-scan at i-save ang lahat ng resibo para sa settlement period.',
  'settlement.helpPopoverStep2':
    'Sa page na ito, pumili ng Money Received period at i-preview ang gastos.',
  'settlement.helpPopoverStep3': 'I-tap ang Sumang-ayon at Makipag-ayos para isumite sa employer.',
  'settlement.helpPopoverNotesHeading': 'Paalala',
  'settlement.helpPopoverNote1':
    'Pagkatapos mag-save ng resibo, kailangan mong magsumite ng settlement bago suriin ng employer.',
  'settlement.helpPopoverNote2':
    'Pagkatapos magsumite, hindi ka na makakapag-upload o mag-edit ng resibo para sa mga petsang iyon hanggang tanggihan/i-unlock ng employer o i-withdraw mo.',
  'settlement.helperQuickActions': 'Mabilis na pagkilos',
  'settlement.helperActionScanTitle': 'I-scan ang resibo',
  'settlement.helperActionScanMeta': 'AI extract at isumite',
  'settlement.helperActionReceiptListTitle': 'Listahan ng resibo',
  'settlement.helperActionReceiptListMeta': 'Tingnan ang isinumite at nakabinbing mga resibo',
  'settlement.helperActionLockTitle': 'Sumang-ayon at Makipag-ayos',
  'settlement.helperActionLockMeta': 'I-lock ang napiling hanay at isumite sa employer',
  'settlement.helperActionHistoryTitle': 'Kasaysayan ng paninirahan',
  'settlement.helperActionHistoryMeta': 'Tingnan ang mga nakaraang talaan ng settlement',
  'settlement.helperDateRangeAria': 'Napiling panahon ng pag-areglo; palawakin upang baguhin ang mga petsa',
  'settlement.helperStatPeriodBudget': 'Natanggap na Pera',
  'settlement.moneyReceivedDetailOpen': 'Buksan ang pera na natanggap na mga detalye',
  'settlement.moneyReceivedDetailTitle': 'Mga detalye ng Natanggap na Pera',
  'settlement.moneyReceivedDetailReceivedDate': 'Oras',
  'settlement.moneyReceivedDetailPeriod': 'Panahon',
  'settlement.moneyReceivedDetailAmount': 'Halaga',
  'settlement.moneyReceivedDetailAddOn': 'Add-on',
  'settlement.moneyGivenDetailOpen': 'Buksan ang Money Given na mga detalye',
  'settlement.moneyGivenDetailTitle': 'Mga detalye ng Binigyang Pera',
  'settlement.helperStatTotalSpent': 'Kabuuang nagastos',
  'settlement.helperStatBalance': 'Balanse',
  'settlement.dailyBreakdownVsBudgetTitle': 'Pang-araw-araw na gastos',
  'settlement.dailyBudgetAmount': 'Pagkakasira ng Daily Money Received',
  'settlement.dailyVsBudgetColBudget': 'Natanggap na Pera',
  'settlement.dailyVsBudgetColExpense': 'Gumastos',
  'settlement.dailyBudgetVariance': 'Diff.',
  'settlement.expensePreview': 'Preview ng gastos',
  'settlement.breakdownModalTitle': 'Pang-araw-araw na breakdown ng gastos',
  'settlement.openBreakdownAria': 'Open Breakdown: araw-araw na bilang ng resibo at halaga',
  'settlement.helperConfirmDateRangeLabel': 'Saklaw ng petsa ng settlement',
  'settlement.helperConfirmDateRangeSeparator': 'sa',
  'settlement.helperConfirmLockNotice': 'Pagkatapos ng settlement, ang mga talaan ng gastos para sa panahong ito ay mai-lock. Dapat i-unlock ng iyong employer ang mga ito bago ka makapag-edit muli.',
  'settlement.helperConfirmPrimary': 'Isumite',
  'settlement.helperSettleButton': 'Sumang-ayon at Makipag-ayos',
  'settlement.confirmAction': 'Kumpirmahin',
  'settlement.helperReviewedByEmployerNotice': 'Nirepaso ng iyong employer ang settlement na ito.',
  'settlement.helperSubmittedNotice': 'Ang isinumiteng settlement ay mayroon na sa hanay ng petsang ito at nakabinbin ang pagsusuri ng employer.',
  'settlement.helperSubmittedRangeNotice': 'Ang isang isinumiteng settlement ay mayroon na sa hanay ng petsa na ito ({{range}}) at nakabinbin ang pagsusuri ng employer.',
  'settlement.helperSubmittedRangesNotice': 'Umiiral na ang mga isinumiteng settlement sa hanay ng petsa na ito ({{ranges}}) at nakabinbin ang pagsusuri ng employer.',
  'settlement.helperSubmittedAndReviewedRangesNotice': 'Umiiral na ang mga isinumite/nasuri na mga settlement sa hanay ng petsa na ito ({{ranges}}). Ang mga isinumiteng item ay nakabinbin ang pagsusuri ng employer.',
  'settlement.confirmOverlapSubmittedRangesError': 'Ang mga napiling petsa ay nagsasapawan ng mga isinumiteng settlement ({{ranges}}). Mangyaring bawiin ang mga ito o hintayin ang pagsusuri ng employer bago magsumite ng mga magkakapatong na petsa.',
  'settlement.confirmOverlapLockedRangesError': 'Ang mga napiling petsa ay nagsasapawan sa mga naka-lock na panahon ng pag-aayos ({{ranges}}). Hilingin sa iyong tagapag-empleyo na i-unlock ang mga ito bago magsumite ng mga magkakapatong na petsa.',
  'settlement.helperConfirmPageTitle': 'Sumang-ayon at Makipag-ayos',
  'settlement.helperConfirmSubtitle': 'Suriin ang mga kabuuan para sa napiling panahon, pagkatapos ay i-lock at isumite sa iyong employer.',
  'settlement.helperHistoryPageTitle': 'Kasaysayan ng paninirahan',
  'settlement.helperHistoryTabBySettlement': 'Sa pamamagitan ng pag-areglo',
  'settlement.helperHistoryTabByMoneyReceived': 'Sa pamamagitan ng perang natanggap',
  'settlement.helperHistoryViewTabsAria': 'View ng kasaysayan ng settlement',
  'settlement.helperResubmitBannerPrefix': 'Walang napapanahong kasunduan ang naisumite para sa panahong ito. I-tap',
  'settlement.helperResubmitBannerLink': 'dito',
  'settlement.helperResubmitBannerSuffix': 'upang isumite.',
  'settlement.helperResubmitBannerLinkAria': 'Pumunta sa Agree & Settle',
  'settlement.helperBackToExpenses': 'Bumalik sa mga gastos at settlement',
  'settlement.totalSpentReceiptHint': 'Kasama ang mga na-save, isinumite, at nasuri na mga resibo.',
  'settlement.period': '{{start}} – {{end}}',
  'settlement.backList': 'Bumalik sa mga pamayanan',
  'apiError.settlementLockedReceipt': 'Ang petsa ng pagtanggap na ito ({{receiptDate}}) ay nasa loob ng isang panahon na naayos na at naka-lock ({{start}} hanggang {{end}}). Hilingin sa iyong employer na i-unlock ang settlement na iyon sa app; pagkatapos ay maaari kang magdagdag, mag-edit, o magtanggal ng mga resibo para sa mga petsang iyon.',
  'apiError.settlementRangeOverlapsLocked': 'Ang mga petsang pinili mo ({{reqStart}} hanggang {{reqEnd}}) ay nagsasapawan sa isang panahon na naayos na at naka-lock ({{start}} hanggang {{end}}). Hilingin sa iyong employer na i-unlock muna ang settlement na iyon, o pumili ng mga petsa na hindi nagsasapawan.',
  'apiError.settlementNoReceiptsAck': 'Walang mga resibo sa hanay ng petsa na ito. Kung gusto mo pa ring mag-lock ng walang laman na panahon, kumpirmahin muna gamit ang on-screen na opsyon.',
  'apiError.budgetOverlapsSettlement': 'Ang panahong Ibinigay ng Pera na ito ay nag-o-overlap sa mga petsa na nabibilang na sa isang umiiral nang settlement. Pumili ng mga petsa na ganap na nasa labas ng bawat panahon ng pag-aayos.',
  'apiError.budgetShrinkReceiptsOutside': 'Masyadong makitid ang mga petsang ito: ang isa o higit pang naka-link na resibo ay may mga petsa sa labas ng bagong hanay. Palawakin ang mga petsang Ibinigay ng Pera o ayusin muna ang mga resibo.',
  'apiError.budgetDeleteLocked': 'Ang Ibinigay na Pera na ito ay hindi maaaring alisin dahil mayroon itong naka-lock na settlement. Resolbahin muna ang settlement.',
  'apiError.budgetMainOverlap': 'Ang panahong Ibinigay ng Pera na ito ay nagsasapawan ng (mga) kasalukuyang panahon: {{ranges}}. Mangyaring pumili ng hindi magkakapatong na hanay ng petsa.',
  'apiError.subBudgetOutOfMainRange': 'Ang panahon ng Add-on Money ay dapat na ganap na nasa loob ng napiling pangunahing panahon.',
  'apiError.mainBudgetLockedBySubmittedSettlement': 'Ang panahong Ibinigay ng Pera na ito ay may isinumiteng settlement at read-only na ngayon. Hindi mo ito maaaring i-edit o alisin.',
  'apiError.receiptDeleteStatusNotAllowed': 'Hindi matatanggal ang resibong ito sa kasalukuyang katayuan nito. Tanging ang mga resibo na naghihintay para sa pagsusuri, na minarkahan bilang nangangailangan ng update, o nakansela ang maaaring tanggalin.',
  'apiError.receiptUpdateStatusNotAllowed': 'Ang resibo na ito ay hindi maaaring i-edit sa ngayon. Maaari ka lamang mag-edit ng mga resibo na naghihintay para sa pagsusuri ng employer o na hiniling sa iyo ng employer na i-update.',
  'apiError.settlementAlreadyUnlocked': 'Naka-unlock na ang settlement na ito. I-refresh ang page para makita ang pinakabagong status.',
  'translation.autoTranslatedTo': 'Awtomatikong isinalin sa {{language}}. Maaaring may mali ang salin.',
  'translation.showOriginal': 'Ipakita ang orihinal',
  'translation.showTranslated': 'Ipakita ang salin',
  'translation.hintButtonAria': 'Impormasyon sa pagsasalin',
  'translation.hintPanelAria': 'Paalala sa awtomatikong pagsasalin',
  'translation.lang.zhHant': 'Tradisyunal na Tsino',
  'translation.lang.zhHans': 'Pinasimpleng Tsino',
  'translation.lang.en': 'Ingles',
  'translation.lang.id': 'Indonesian',
  'translation.lang.fil': 'Filipino',
  'family.navLink': 'Mga miyembro ng pamilya',
  'family.title': 'Mga Kagustuhan sa Miyembro ng Pamilya',
  'family.subtitle': 'Maaaring magdagdag o mag-edit ang mga employer; maaaring tingnan ng parehong partido.',
  'family.listConsentLabel': 'Kinukumpirma kong pumayag ang mga miyembro ng pamilya na ibahagi ang kanilang data.',
  'family.listConsentHint': 'Lagyan ng check ang kahon sa itaas para tingnan o pamahalaan ang data ng miyembro ng pamilya.',
  'family.addMember': 'Magdagdag ng miyembro',
  'family.addMemberAria': 'Magdagdag ng miyembro ng pamilya',
  'family.editMember': 'I-edit',
  'family.editMemberAria': 'I-edit ang miyembro ng pamilya',
  'family.deleteMember': 'Alisin',
  'family.deleteConfirm': 'Alisin ang miyembro ng pamilya na ito? Hindi na ito maaaring bawiin.',
  'family.empty': 'Wala pang kapamilya',
  'family.emptyHint': 'I-tap ang “Magdagdag ng miyembro” para magdagdag ng isa.',
  'family.emptyHintHelper': 'Ang employer lamang ang maaaring magdagdag ng mga miyembro ng pamilya. Makipag-ugnayan sa iyong employer kung kinakailangan.',
  'family.field.name': 'Pangalan',
  'family.field.nickname': 'palayaw',
  'family.formField.nickname': 'Palayaw (opsyonal)',
  'family.formField.birthday': 'Kaarawan (opsyonal)',
  'family.formField.remark': 'Mga regular na aktibidad (opsyonal)',
  'family.formField.foodPreference': 'Kagustuhan sa pagkain (opsyonal)',
  'family.formField.foodAllergy': 'Allergy sa pagkain (opsyonal)',
  'family.formField.medicalCondition': 'Medikal na kondisyon (opsyonal)',
  'family.formField.hashtags': 'Mga tag (opsyonal)',
  'family.placeholder.name': 'hal. Ben Chan',
  'family.placeholder.nickname': 'hal. kuya',
  'family.placeholder.foodPreference': 'hal. banayad na pagkain, mahilig sa mansanas',
  'family.placeholder.foodAllergy': 'hal. mani',
  'family.placeholder.medicalCondition': 'hal. mataas na presyon ng dugo, umiinom ng pang-araw-araw na gamot',
  'family.placeholder.hashtags': 'hal. magaan na diyeta, mababang asin',
  'family.field.birthday': 'Birthday',
  'family.field.age': 'Edad',
  'family.field.foodPreference': 'Kagustuhan sa pagkain',
  'family.field.foodAllergy': 'Allergy sa pagkain',
  'family.field.medicalCondition': 'Medikal na kondisyon',
  'family.field.remark': 'Mga regular na aktibidad',
  'family.field.remarkPlaceholder': 'hal. Klase ng football - Sat 10am',
  'family.field.hashtags': 'Mga tag',
  'family.field.hashtagsHint': 'Maglagay ng ilang mga tag na pinaghihiwalay ng mga kuwit, semicolon, o mga bagong linya.',
  'family.birthday.optionalHint': 'Opsyonal. Maaari mong iwanang blangko ang taon at piliin lamang ang buwan at araw.',
  'family.birthday.exampleHint': 'hal. taong 2011, buwan 03, araw 15; o pumili ng buwan at araw lamang (iwang blangko ang taon).',
  'family.birthday.yearOptional': 'Taon (opsyonal)',
  'family.birthday.month': 'buwan',
  'family.birthday.day': 'Araw',
  'family.display.birthdaySkipped': 'Walang birthday sa file',
  'family.display.ageWithYear': '{{age}} taong gulang (ipinanganak sa {{year}})',
  'family.display.birthdayMonthDay': '{{month}}/{{day}}',
  'family.validation.birthdayNeedMonthDay': 'Upang magdagdag ng kaarawan, piliin ang parehong buwan at araw.',
  'family.validation.birthdayInvalid': 'Walang bisa ang kaarawan na iyon. Suriin ang taon, buwan, at araw.',
  'family.formConsentLabel': 'Kinukumpirma kong pumayag ang taong ito na ibahagi ang kanilang data.',
  'family.formCreateTitle': 'Magdagdag ng miyembro ng pamilya',
  'family.formEditTitle': 'I-edit ang miyembro ng pamilya',
  'family.formSubmit': 'I-save',
  'family.formSubmitting': 'Sine-save...',
  'family.formCancel': 'Kanselahin',
  'family.loadError': 'Hindi ma-load ang mga miyembro ng pamilya',
  'family.saveError': 'Nabigo ang pag-save',
  'family.deleteError': 'Nabigo ang pag-alis',
  'family.validation.consentRequired': 'Mangyaring kumpirmahin ang pahintulot bago i-save.',
  'inventory.title': 'Gawain ng Home Stock',
  'inventory.subtitle': 'Magdagdag ng mga larawan sa mga batch (maaaring masakop ng isang larawan ang maraming item), tumutugma ang AI sa iyong checklist, pagkatapos ay magdagdag ng mga larawan o manu-manong kumpirmahin bago isumite',
  'inventory.stocktakePanelTitle': 'Stocktake na mga larawan',
  'inventory.stocktakePanelHint': 'Ang isang larawan ay maaaring magpakita ng maramihang mga item sa listahan.',
  'inventory.stocktakeMaxFilesHint': 'Hanggang sa 10 mga larawan sa isang pagkakataon',
  'inventory.uploadedStocktakePhotosHeading': 'Na-upload ang Home Stock na mga larawan',
  'inventory.uploadedStocktakePhotoAlt': 'Home Stock photo {{n}}',
  'inventory.enlargePhotoAria': 'Tingnan ang buong laki ng larawan ng Home Stock',
  'inventory.removePhotoAria': 'Alisin ang larawang ito sa Home Stock',
  'inventory.removeStocktakePhotoTitle': 'Alisin ang larawang ito?',
  'inventory.removeStocktakePhotoDescription': 'Maaari mong alisin ang mga larawan bago isumite. Kung ginamit ng anumang linya ang larawang ito para sa AI, iki-clear iyon—magdagdag ng bagong larawan o manu-manong magtakda ng mga antas.',
  'inventory.removeStocktakePhotoConfirm': 'Alisin',
  'inventory.notRecognizedByAi': 'Matapos ma-upload ang kahit isang larawan, ang mga linyang ito ay hindi pa rin naitugma ng AI. Magdagdag ng isa pang larawan o pumili ng mga antas ng stock sa ibaba (maaari nilang ibahagi ang parehong batch na larawan kapag nagsumite ka).',
  'inventory.matchedByAiHint': 'Napuno ng AI (maaari mo itong baguhin)',
  'inventory.stockLevel': 'Antas ng stock',
  'inventory.stockLevelRequired': 'Pumili ng antas ng stock para sa bawat item sa listahan.',
  'inventory.level.full': 'Puno',
  'inventory.level.half': 'kalahati',
  'inventory.level.low': 'Mababa',
  'inventory.level.empty': 'Walang laman',
  'inventory.level.unknown': '—',
  'inventory.photoLabel': 'Larawan ng item',
  'inventory.analyze': 'Pagsusuri ng AI',
  'inventory.analyzing': 'Sinusuri...',
  'inventory.stocktakeUploading': 'Ina-upload…',
  'inventory.stocktakeUploadingProgress': 'Ina-upload ang {{current}} / {{total}}',
  'inventory.analyzeNeedPhoto': 'Pumili ng larawan bago suriin',
  'inventory.analyzeError': 'Nabigo ang pagsusuri. Subukan muli.',
  'inventory.stocktakeDailyAiLimitPhotoSaved': 'Naubos na ang iyong pang-araw-araw na AI image quota (ibinahagi sa pag-scan ng resibo). Walang tumatakbong AI para sa pag-upload na ito. Kung nagtagumpay ang pag-upload sa cloud, mananatili ang thumbnail sa listahan—manu-manong ipasok ang mga antas ng stock; nire-reset ang quota sa susunod na araw ng UTC.',
  'inventory.needAtLeastOneBatchPhoto': 'Mag-upload ng kahit isang Home Stock na larawan.',
  'inventory.needPhotoBeforeStockLevels': 'Mag-upload muna ng kahit isang Home Stock na larawan para sa lokasyong ito. Ang mga antas ng stock, pag-expire, at manu-manong pagpasok ng item ay lalabas pagkatapos nito.',
  'inventory.unmatchedUseSharedPhotoHint': 'Kung mayroon nang na-upload na larawan ang batch na ito, ibabahagi ng mga hindi nakikilalang linya ang parehong link na iyon kapag nagsumite ka; hindi mo kailangan ng hiwalay na larawan para sa bawat linya.',
  'inventory.emptyTemplate': 'Ang checklist na ito ay walang mga item at hindi maaaring isumite',
  'inventory.helperOnly': 'Mga katulong lang ang pwedeng mag-stock',
  'inventory.chainBlockedBanner': 'Naghihintay pa rin ng pagsusuri ang dating stock ng bahay, kaya naka-lock ang home stock task na ito sa ngayon.',
  'inventory.wizard.locationStepBadge': 'Lokasyon {{current}} ng {{total}}: {{name}}',
  'inventory.wizard.reviewPhaseHint': 'Pagsusuri: kumpirmahin ang oras ng pagkumpleto, pagkatapos ay isumite',
  'inventory.wizard.reviewTitle': 'Buod ayon sa lokasyon',
  'inventory.wizard.reviewLocationSummaryPhotos': '{{photos}} mga larawan',
  'inventory.wizard.reviewLocationSummaryEmptyCategories': '{{noCat}} mga kategorya na minarkahan na walang laman',
  'inventory.wizard.noItemsHeading': 'Walang mga item para sa mga kategoryang ito sa lokasyong ito',
  'inventory.wizard.noItemsHint': 'Kung ang isang kategorya ay talagang walang mga item dito, lagyan ng tsek upang kumpirmahin (walang antas ng stock na kailangan).',
  'inventory.wizard.noItemsHintTickFirst': 'Dumaan muna sa bawat kategorya ng employer: lagyan ng tsek sa ibaba kung talagang wala dito para sa kategoryang iyon; pagkatapos lamang punan ang mga row ng stock at expiry para sa mga natukoy o manu-manong idinagdag na item.',
  'inventory.wizard.noItemsConfirmModalTitle': 'Kumpirmahin ang mga walang laman na kategorya',
  'inventory.wizard.noItemsConfirmModalDescription': 'Ang mga kategoryang ito ay walang binilang na mga item sa lokasyong ito. Lagyan ng tsek ang bawat linya ng kumpirmasyon, pagkatapos ay pindutin ang Kumpirmahin upang magpatuloy.',
  'inventory.wizard.noItemCategoryAria': 'Walang mga item para sa kategoryang “{{category}}” sa lokasyong ito',
  'inventory.wizard.noItemCategoryLabel': 'Walang mga item para sa kategoryang “{{category}}” sa lokasyong ito',
  'inventory.wizard.rowSkippedNoItemsCategory': 'Ang kategorya ng row na ito ay minarkahan bilang walang mga item sa lokasyong ito.',
  'inventory.wizard.manualItemNoItemsCategoryBanner': 'Ang kategoryang ito ay minarkahan bilang "walang mga item ng ganitong uri sa lokasyong ito." Maaari ka pa ring maglagay ng stock at mag-expire dito; para isama ito sa iyong isinumite, linisin muna ang markang iyon.',
  'inventory.wizard.continueNextLocation': 'Magpatuloy sa susunod na lokasyon',
  'inventory.wizard.goToReview': 'Pumunta sa pagsusuri',
  'inventory.wizard.photoRequiredPerLocation': 'Mag-upload ng kahit isang stocktake na larawan para sa bawat lokasyon.',
  'inventory.wizard.noItemsConflict': 'Minarkahan mo ang kategoryang ito bilang walang mga item; malinaw na antas ng stock para sa mga row na iyon.',
  'inventory.wizard.categoryMarkNoItems': 'Ang kategoryang “{{category}}” ay walang katugmang mga hilera ng listahan; markahan ang "walang mga item para sa kategoryang ito".',
  'inventory.wizard.helperSingleStep1Badge': 'Hakbang 1/2: kumuha o mag-upload ng mga larawan ng Home Stock',
  'inventory.wizard.helperSingleStep2Badge': 'Hakbang 2/2: ilagay ang mga antas ng stock at mag-expire',
  'inventory.wizard.continueToStockEntry': 'Susunod: ilagay ang mga detalye ng stock',
  'inventory.wizard.locationHubTitle': 'Mga lokasyon',
  'inventory.wizard.locationHubHint': 'Magtrabaho sa anumang lokasyon sa anumang pagkakasunud-sunod — mag-tap ng card para lumipat. Ang bawat lokasyon ay nangangailangan ng hindi bababa sa isang larawan at mga nakumpletong kategorya/mga panuntunan sa stocktake bago ka makapagsumite mula sa buod.',
  'inventory.wizard.locationHubReviewHint': 'Suriin ang bawat lokasyon ay mukhang tama. I-tap ang "Magpatuloy sa pag-edit sa lokasyong ito" upang bumalik kapag kailangan mo ng mga pagbabago.',
  'inventory.wizard.locationHubProgress': 'Handa nang isumite: {{done}} / {{total}} na lokasyon',
  'inventory.wizard.locationHubSelectAria': 'Lumipat sa {{name}}',
  'inventory.wizard.locationHubCurrentBadge': 'Pag-edit',
  'inventory.wizard.locationHubStatusPhotoOk': 'Idinagdag ang larawan',
  'inventory.wizard.locationHubStatusPhotoMissing': 'Kulang ang larawan',
  'inventory.wizard.locationHubStatusReady': 'OK ang lahat ng kinakailangang field',
  'inventory.wizard.locationHubStatusIncomplete': 'Hindi pa kumpleto',
  'inventory.wizard.editLocationFromReview': 'Ipagpatuloy ang pag-edit sa lokasyong ito',
  'inventory.wizard.editLocationFromReviewAria': 'Bumalik sa pag-edit ng {{name}}',
  'inventory.wizard.notAllLocationsReady': 'Ang ilang mga lokasyon ay hindi pa rin kumpleto — gamitin ang "Mga Lokasyon" upang lumipat at tapusin ang mga larawan, kategorya, at mga field ng stocktake (mga update sa pag-unlad kapag handa na).',
  'inventory.wizard.selectLocationTitle': 'Pumili ng lokasyon',
  'inventory.wizard.selectLocationSubtitle': 'Pumili ng lokasyon upang simulan ang iyong bilang ng imbentaryo.',
  'inventory.wizard.hubInfoBanner': 'Kumpletuhin ang bawat nakatalagang lokasyon bago ka makapagsumite.',
  'inventory.wizard.hubLocationsCompleted': '{{done}} / {{total}} na lokasyon ang nakumpleto',
  'inventory.wizard.tapToStart': 'I-tap para magsimula',
  'inventory.wizard.locationCompletedLine': 'Nakumpleto',
  'inventory.wizard.locationHubStatusInProgress': 'Higit pang mga detalye ang kailangan',
  'inventory.wizard.locationHubStatusNeedsStock': 'Pumili ng antas ng stock para sa mga item',
  'inventory.wizard.locationHubStatusNeedsExpiry': 'Pumili ng opsyon sa pag-expire para sa mga item',
  'inventory.wizard.locationHubStatusNeedsCategories': 'I-tap ang Magpatuloy sa Suriin ang mga item upang kumpirmahin ang mga walang laman na kategorya',
  'inventory.wizard.hubNextStep': 'Susunod na hakbang',
  'inventory.wizard.hubNextDisabledHint': 'Tapusin ang lahat ng mga lokasyon bago magpatuloy.',
  'inventory.wizard.stepBadge': 'Hakbang {{current}} / {{total}}',
  'inventory.wizard.stepBadgeWithSubstep': 'Hakbang {{major}}{{sub}} / {{total}}',
  'inventory.wizard.stepBadgeWithSubstepAria': 'Kasalukuyang hakbang {{major}}{{sub}} ng {{total}}',
  'inventory.wizard.selectLocationIncompleteSection': 'Hindi kumpleto',
  'inventory.wizard.selectLocationCompleteSection': 'Nakumpleto',
  'inventory.wizard.selectLocationModalCloseAria': 'Isara ang tagapili ng lokasyon',
  'inventory.wizard.selectLocationFinalReviewButton': 'Panghuling pagsusuri',
  'inventory.wizard.leaveHomeStockWorkButton': 'Umalis sa Home Stock work',
  'inventory.wizard.viewThisTaskButton': 'Tingnan ang gawaing ito',
  'inventory.wizard.leaveHomeStockWorkConfirmTitle': 'Umalis sa Home Stock work?',
  'inventory.wizard.leaveHomeStockWorkConfirmDescription': 'Ang anumang hindi mo naisumite ay hindi mase-save. Bumalik sa listahan ng gawain sa Today?',
  'inventory.wizard.progressAria': 'Pag-unlad tungkol sa {{percent}} porsyento',
  'inventory.wizard.photosStepTitle': 'Kumuha ng mga larawan',
  'inventory.wizard.photosStepSubtitle': 'Kumuha o mag-upload ng mga larawan ng Home Stock para sa {{location}}.',
  'inventory.wizard.reviewItemsTitle': 'Suriin ang mga item',
  'inventory.wizard.reviewItemsSubtitle': 'I-verify ang mga item at i-update ang kanilang katayuan.',
  'inventory.wizard.continueToReviewItems': 'Patuloy na suriin ang mga item',
  'inventory.wizard.continueWithAiAnalyze': 'Sinusuri at suriin ng AI ang mga item ⮕',
  'inventory.wizard.continueWithoutAi': 'Suriin ang mga item (walang AI) ⮕',
  'inventory.wizard.aiSelectModalTitle': 'Pumili ng mga larawang susuriin',
  'inventory.wizard.aiSelectModalDescription': 'Ang mga nasuri at hindi pa nasuri na mga larawan ay nakalista nang magkahiwalay. Tanging mga hindi pa nasusuri na mga larawan ang pinili bilang default.',
  'inventory.wizard.aiSelectModalNotAnalyzedHeading': 'Hindi pa nasusuri',
  'inventory.wizard.aiSelectModalAnalyzedHeading': 'Nasuri na',
  'inventory.wizard.aiSelectModalSectionEmpty': '(wala)',
  'inventory.wizard.aiSelectModalConfirm': 'Patakbuhin ang pagsusuri ng AI',
  'inventory.wizard.aiSelectPhotoCheckboxAria': 'Suriin ang larawan {{n}}',
  'inventory.wizard.reanalyzeConfirmTitle': 'Muling suriin ang mga larawan?',
  'inventory.wizard.reanalyzeConfirmDescription': 'Ang data para sa {{items}} (mga) item na naka-link sa napiling {{photos}} (mga) larawan ay iki-clear at papalitan ng mga bagong resulta ng AI. Ang mga item sa iba pang mga larawan ay hindi nagbabago.',
  'inventory.wizard.reanalyzeConfirmProceed': 'Kumpirmahin at suriin',
  'inventory.stocktakeDailyAiLimitBatchCancelled': 'Ang AI quota ngayon ay hindi sapat; nakansela ang pagsusuri para sa lahat ng napiling larawan.',
  'inventory.removeStocktakePhotoWithItemsDescription': 'Ang larawang ito ay naka-link sa {{count}} (mga) item. Tanggalin ang larawan at ang mga item na iyon?',
  'inventory.removeStocktakePhotoDeleteWithItems': 'Tanggalin ang larawan at mga naka-link na item',
  'inventory.removeStocktakePhotoKeepAll': 'Panatilihin ang larawan at mga item',
  'inventory.manualAdd.photoRequired': 'Piliin kung saang larawan kabilang ang item na ito.',
  'inventory.manualAdd.photoPlaceholder': 'Pumili ng larawan',
  'inventory.itemPhotoLabel': 'Larawan',
  'inventory.itemPhotoPickerAria': 'Pumili ng larawan ng item',
  'task.review.inventoryItemPhotoAria': 'Larawan ng item',
  'inventory.wizard.saveAndNextLocation': 'I-save at susunod na lokasyon',
  'inventory.wizard.continueToFinalReview': 'Magpatuloy sa huling pagsusuri',
  'inventory.wizard.finalReviewTitle': 'Panghuling pagsusuri',
  'inventory.wizard.finalReviewSubtitle': 'I-verify ang iyong mga bilang at buod bago ipaalam sa iyong employer.',
  'inventory.wizard.statLowStock': 'Mababang stock na mga item',
  'inventory.wizard.statExpiringSoon': 'Malapit nang mag-expire',
  'inventory.wizard.statTotalCategories': 'Kabuuang mga kategorya',
  'inventory.wizard.statTotalPhotos': 'Kabuuang mga larawan',
  'inventory.statDetailModal.lowStockTitle': 'Mababang stock na mga item',
  'inventory.statDetailModal.expiringTitle': 'Nag-e-expire na mga item (sa loob ng {{days}} na araw)',
  'inventory.statDetailModal.categoryLabel': 'Kategorya',
  'inventory.statDetailModal.locationLabel': 'Lokasyon',
  'inventory.statDetailModal.expiryHeading': 'Katayuan ng pag-expire',
  'inventory.statDetailModal.empty': 'Walang mga item na ilista.',
  'inventory.statDetailModal.closeButton': 'Isara',
  'inventory.statDetailModal.closeAria': 'Isara ang dialog ng mga detalye',
  'inventory.statDetailModal.dismissBackdropAria': 'Isara ang mga detalye (i-tap ang backdrop)',
  'inventory.statDetailModal.openLowStockAria': 'Buksan ang mababang mga detalye ng stock, {{count}} na mga item',
  'inventory.statDetailModal.openExpiringAria': 'Buksan ang mga nag-e-expire na detalye, {{count}} na mga item',
  'inventory.wizard.locationDetailsSection': 'Buod ng lokasyon',
  'inventory.wizard.submissionInfoSection': 'Impormasyon sa pagsusumite',
  'inventory.wizard.finalReviewDateLabel': 'Petsa',
  'inventory.wizard.finalReviewCompletionTimeLabel': 'Oras ng pagkumpleto',
  'inventory.wizard.readyToSubmitTitle': 'Handa nang isumite?',
  'inventory.wizard.readyToSubmitDisclaimer': 'Ang pagsusumite ay nag-aabiso sa iyong tagapag-empleyo para sa pagsusuri. Hindi mo maaaring i-edit ang mga bilang na ito pagkatapos isumite.',
  'inventory.wizard.sendReport': 'Isumite',
  'inventory.wizard.addItemManuallyTitle': 'Magdagdag ng item nang manu-mano',
  'inventory.wizard.renameItemPrompt': 'Pangalan ng item',
  'inventory.wizard.renameItemAria': 'I-edit ang pangalan ng item',
  'inventory.wizard.removeManualItemTitle': 'Alisin ang item na ito?',
  'inventory.wizard.removeManualItemDescription': 'Aalisin nito ang “{{name}}” at ang stock at data ng pag-expire nito para sa lokasyong ito. Hindi na ito maaaring bawiin.',
  'inventory.wizard.reviewLocationBadgeAria': 'Kasalukuyang lokasyon: {{location}}',
  'inventory.wizard.editCategoryAria': 'I-edit ang kategorya',
  'inventory.wizard.editAllLocations': 'I-edit lahat',
  'inventory.wizard.locationItemsBadge': 'Mga bagay',
  'inventory.wizard.reviewLocationStatItemsCaption': 'MGA ITEM',
  'inventory.wizard.reviewLocationStatEmptyCatCaption': 'WALANG laman na PUSA.',
  'inventory.wizard.reviewLocationStatEmptyCatCaptionFull': 'Mga walang laman na kategorya',
  'inventory.wizard.reviewLocationStatPhotosCaption': 'MGA LITRATO',
  'inventory.wizard.previewLocationResults': 'Silipin',
  'inventory.wizard.previewLocationResultsAria': 'I-preview ang mga resulta ng stock sa bahay para sa {{name}}',
  'inventory.wizard.previewLocationResultsCloseAria': 'Isara ang preview ng mga resulta ng stock sa bahay',
  'inventory.wizard.previewLocationResultsDismissBackdropAria': 'Isara ang preview ng mga resulta ng stock sa bahay (i-tap ang backdrop)',
  'inventory.manualAdd.title': 'Magdagdag ng isang item nang manu-mano',
  'inventory.manualAdd.sectionAria': 'Manu-manong kategorya at pagpasok ng item',
  'inventory.manualAdd.expandToggleAria': 'Palawakin ang pagdaragdag ng item nang manu-mano',
  'inventory.manualAdd.collapseToggleAria': 'I-collapse ang pagdaragdag ng item nang manu-mano',
  'inventory.manualAdd.hint': 'Kung ang isang item ay nawawala sa listahan ng imbentaryo o hindi nakita sa mga larawan, i-type ang kategorya at pangalan nito. Kapag tinukoy ng employer ang mga kategorya para sa gawaing ito, pumili ng isa mula sa listahan.',
  'inventory.manualAdd.saveToMasterHint': 'Pinahihintulutan ng iyong tagapag-empleyo ang mga katulong na i-edit ang listahan ng master ng imbentaryo: kapag nagtagumpay ang paggawa, nai-save din ito doon (kung nabigo ito, maaari pa ring isama ang item sa pagsusumiteng ito lamang).',
  'inventory.manualAdd.onlySubmissionHint': 'Kung naka-disable ang pag-edit sa master list ng imbentaryo: ang mga item na idinagdag mo dito ay isinumite sa gawaing Home Stock na ito lamang at hindi idinaragdag sa master list bilang default.',
  'inventory.manualAdd.categoryLabel': 'Kategorya',
  'inventory.manualAdd.categoryPlaceholder': 'Pumili ng kategorya',
  'inventory.manualAdd.categoryOtherLabel': 'Kategorya (uri)',
  'inventory.manualAdd.categoryOtherPlaceholder': 'Pangalan ng kategorya (hanggang 120 character)',
  'inventory.manualAdd.itemNameLabel': 'Pangalan ng item',
  'inventory.manualAdd.itemNamePlaceholder': 'hal. Sabong panlaba',
  'inventory.manualAdd.addButton': 'Magdagdag ng item',
  'inventory.manualAdd.adding': 'Idinaragdag…',
  'inventory.manualAdd.validationBoth': 'Ilagay ang parehong kategorya at pangalan ng item.',
  'inventory.manualAdd.validationCategory': 'Pumili ng isa sa mga kategoryang tinukoy para sa gawaing ito.',
  'inventory.manualAdd.stockRequired': 'Pumili ng antas ng stock (puno / kalahati / mababa / walang laman).',
  'inventory.manualAdd.expiryChoiceRequired': 'Piliin ang "walang expiry" o "may expiry date(s)", at ilagay ang mga petsa kung kinakailangan.',
  'inventory.manualAdd.limitReached': 'Maaari kang magdagdag ng hanggang {{max}} na mga manu-manong item.',
  'inventory.manualAdd.addFailed': 'Hindi maidagdag ang item. Subukan muli.',
  'inventory.manualAdd.remove': 'Alisin',
  'inventory.manualAdd.removeAria': 'Alisin ang manu-manong idinagdag na item na {{name}}',
  'inventory.manualAdd.rowCategoryBadge': 'Kategorya: {{category}}',
  'inventory.manualAdd.rowCategoryEditLabel': 'Kategorya (nae-edit)',
  'inventory.expiry.sectionAria': 'Mga petsa ng pag-expire',
  'inventory.expiry.sectionTitle': 'Expired',
  'inventory.expiry.noExpiryLabel': 'Walang expire',
  'inventory.expiry.noExpiryAria': '{{item}}: walang expire',
  'inventory.expiry.hasDatesLabel': 'May (mga) petsa ng pag-expire',
  'inventory.expiry.hasDatesAria': '{{item}}: ilagay ang (mga) petsa ng pag-expire',
  'inventory.expiry.datePickerAria': '{{item}} expiration date {{n}}',
  'inventory.expiry.removeDate': 'Alisin',
  'inventory.expiry.removeDateAria': 'Alisin ang {{item}} expiration date {{n}}',
  'inventory.expiry.addDate': 'Magdagdag ng isa pang petsa ng pag-expire',
  'inventory.expiry.maxDatesHint': 'Hanggang sa 10 mga petsa ng pag-expire bawat item.',
  'inventory.expiry.required': 'Maglagay ng kahit isang expiry date para sa “{{item}}”, o piliin ang “no expiry”.',
  'inventory.expiry.chooseModeHint': 'Piliin ang “walang expiry” o “may expiry date (s)”.',
  'inventory.expiry.choiceRequired': 'Piliin kung paano pangasiwaan ang pag-expire para sa “{{item}}” (walang expiry o isa o higit pang mga petsa).',
  'inventory.reviewLinesHeading': 'Mga item sa stocktake',
  'task.inventory.newTaskTitle': 'Lumikha ng Home Stock',
  'task.inventory.editTaskTitle': 'I-edit ang Home Stock',
  'task.inventory.loadError': 'Hindi ma-load ang data ng imbentaryo',
  'task.inventory.employerOnly': 'Mga account ng employer lang',
  'task.inventory.chainHint': 'Dapat kumpletuhin ng mga katulong ang Home Stock sa takdang petsa. Hindi ka maaaring magtrabaho sa ibang pagkakataon hanggang sa maaprubahan ang lahat ng nauna. Itakda ang pag-ulit kapag gumawa ka o nag-edit ng Home Stock (wala sa checklist).',
  'task.inventory.listScheduleMovedHint': 'Ang checklist ay isang hanay lamang ng mga line item. Itakda ang pag-ulit kapag gumawa ka ng gawain sa Home Stock.',
  'task.inventory.editListHint': 'Pagkatapos mong baguhin ang checklist, gagamitin ng helper stocktake flow at mga pagsusumite sa hinaharap ang mga bagong line item.',
  'task.inventory.editListItemsPreview': 'Mga item sa checklist na ito',
  'task.inventory.editListEmpty': 'Ang checklist na ito ay wala pang mga item',
  'task.inventory.editChecklistItemsHeading': 'Mga item sa linya ng checklist',
  'task.inventory.editChecklistItemsSub': 'Pumili ng mga item sa imbentaryo na isasama. Ang order ay sumusunod sa iyong listahan ng imbentaryo. Gamitin ang berdeng pindutan ng pag-save, o i-save ang gawain sa ibaba upang magpatuloy.',
  'task.inventory.editTaskOptionsHeading': 'Gawain ng Home Stock',
  'task.inventory.editTaskSubmitHint': 'Upang i-save lamang ang checklist, gamitin ang berdeng button na "I-save ang mga item sa linya ng listahan". Ang pangunahing pindutan ay nagse-save din ng pamagat, paglalarawan, petsa, abiso, at nagbubuklod sa gawaing ito sa napiling checklist.',
  'task.inventory.newTaskChecklistHint': 'Pumili ng mga item sa imbentaryo para sa checklist na ito. Kung babaguhin mo ang mga checkbox, ise-save ang listahan bago magawa ang gawain.',
  'task.inventory.sections.lists': 'Mga checklist',
  'task.inventory.createListCta': 'Bagong checklist',
  'task.inventory.noListsHint': 'Wala pang checklist. Gumawa ng checklist at magdagdag muna ng mga line item.',
  'task.inventory.createListTitle': 'Bagong checklist',
  'task.inventory.listNameLabel': 'Pangalan ng checklist',
  'task.inventory.scheduleLabel': 'Iskedyul',
  'task.inventory.schedule.none': 'Walang umuulit na iskedyul (manu-manong lumikha ng mga gawain)',
  'task.inventory.schedule.weekly': 'Linggu-linggo',
  'task.inventory.schedule.monthlyFirstWday': 'Unang araw ng linggo ng buwan',
  'task.inventory.weekdayLabel': 'Araw ng Linggo',
  'task.inventory.createListError': 'Hindi makalikha ng checklist',
  'task.inventory.createListSuccess': 'Nagawa ang checklist',
  'task.inventory.listNameRequired': 'Maglagay ng pangalan ng checklist',
  'task.inventory.assignItemsTitle': 'Ang checklist na ito ay walang mga item',
  'task.inventory.assignItemsHint': 'Pumili ng mga item mula sa iyong imbentaryo, o magdagdag muna ng bagong item.',
  'task.inventory.quickAddItem': 'Pangalan ng item',
  'task.inventory.addItemCta': 'Idagdag sa imbentaryo',
  'task.inventory.createItemError': 'Hindi maidagdag ang item',
  'task.inventory.createItemSuccess': 'Idinagdag ang item sa imbentaryo',
  'task.inventory.itemNameRequired': 'Maglagay ng pangalan ng item',
  'task.inventory.itemNameLabel': 'Pangalan ng item',
  'task.inventory.renameItemCta': 'Palitan ang pangalan',
  'task.inventory.removeFromListCta': 'Alisin sa lahat ng checklist ng stocktake',
  'task.inventory.editListItemsModalCta': 'I-edit ang mga item sa checklist',
  'task.inventory.removeListCta': 'Tanggalin ang checklist',
  'task.inventory.removeListConfirmTitle': 'I-delete itong Home Stock checklist?',
  'task.inventory.removeListConfirmBody': 'Pagkatapos ng pagtanggal, lahat ng aktibong gawain sa Home Stock na naka-link sa checklist na ito ay mag-expire at dapat pumili ng isa pang checklist.',
  'task.inventory.removeListAffectedTasksCount': 'Bilang ng mga apektadong gawain: {{count}}',
  'task.inventory.removeListAffectedTasksLabel': 'Apektadong mga gawain sa Home Stock:',
  'task.inventory.removeListConfirmCta': 'Tanggalin ang checklist',
  'task.inventory.removeListSuccess': 'Na-delete ang checklist',
  'task.inventory.removeListError': 'Hindi matanggal ang checklist',
  'task.inventory.updateListSuccess': 'Na-update ang pangalan ng checklist',
  'task.inventory.updateListError': 'Hindi ma-update ang pangalan ng checklist',
  'task.inventory.renameListModalTitle': 'Palitan ang pangalan ng checklist',
  'task.inventory.renameListModalOpenCta': 'Palitan ang pangalan ng checklist',
  'task.inventory.addedButNotSelected': 'Idinagdag lang sa imbentaryo. Naabot ang maximum na checklist, kaya hindi ito napili.',
  'task.inventory.createListUseHint': 'Pagkatapos gawin ang checklist na ito, i-save muna ang mga item sa checklist para magamit ito.',
  'task.inventory.removeFromListConfirmTitle': 'Alisin ang item na ito sa lahat ng checklist ng stocktake?',
  'task.inventory.removeFromListConfirmBody': 'Kumpirmahin na alisin? Hindi ma-undo kapag nakumpirma na.',
  'task.inventory.removeFromListConfirmCta': 'Alisin sa lahat ng checklist ng stocktake',
  'task.inventory.renameItemModalTitle': 'Palitan ang pangalan ng item',
  'task.inventory.renameItemSave': 'I-save',
  'task.inventory.updateItemError': 'Hindi ma-update ang item',
  'task.inventory.maxItemsNote': '{{count}} item ang napili',
  'task.inventory.saveListItemsCta': 'I-save ang mga item sa checklist',
  'task.inventory.saveListItemsError': 'Hindi ma-save ang mga item',
  'task.inventory.saveListItemsSuccess': 'Na-save ang mga item sa checklist',
  'task.inventory.pickAtLeastOneItem': 'Pumili ng kahit isang item',
  'task.inventory.formHeading': 'Gumawa ng gawaing Home Stock',
  'task.inventory.wizard.stepOf': 'Hakbang {{current}} / {{total}}',
  'task.inventory.wizard.step1Title': 'Pamagat at paglalarawan',
  'task.inventory.wizard.step2Title': 'Mga lokasyon',
  'task.inventory.wizard.step3Title': 'Mga kategorya',
  'task.inventory.wizard.step4Title': 'Iskedyul at petsa',
  'task.inventory.wizard.step5Title': 'Mga abiso',
  'task.inventory.wizard.step6Title': 'Checklist at mga item',
  'task.inventory.wizard.step7Title': 'Suriin at gumawa',
  'task.inventory.wizard.next': 'Susunod',
  'task.inventory.wizard.back': 'Bumalik',
  'task.inventory.wizard.reviewConfirm': 'Lumikha ng gawain',
  'task.inventory.wizard.reviewSave': 'I-save ang mga pagbabago',
  'task.inventory.wizard.categoriesHint': 'Magdagdag ng hindi bababa sa isang kategorya (mga mungkahi sa ibaba).',
  'task.inventory.wizard.locationsHint': 'Magdagdag ng kahit isang lokasyon (mga suhestyon sa ibaba).',
  'task.inventory.wizard.suggestHeading': 'Mga mungkahi',
  'task.inventory.suggest.location.kitchen': 'Kusina',
  'task.inventory.suggest.location.fridge': 'Refrigerator',
  'task.inventory.suggest.location.storeRoom': 'Bodega',
  'task.inventory.suggest.location.livingRoom': 'Sala',
  'task.inventory.suggest.location.bathroomA': 'Banyo A',
  'task.inventory.suggest.location.bathroomB': 'Banyo B',
  'task.inventory.suggest.category.food': 'Pagkain',
  'task.inventory.suggest.category.drinks': 'Inumin',
  'task.inventory.suggest.category.babyFood': 'Pagkain ng Sanggol at Bata',
  'task.inventory.suggest.category.babyDrinks': 'Inumin ng Sanggol at Bata',
  'task.inventory.suggest.category.elderlyFood': 'Pagkain ng Matatanda',
  'task.inventory.suggest.category.petFood': 'Pagkain ng Alagang Hayop',
  'task.inventory.suggest.category.dryGoods': 'Tuyong Paninda',
  'task.inventory.suggest.category.chilledGoods': 'Nakalamig na Paninda',
  'task.inventory.wizard.addCategoryPlaceholder': 'Mag-type ng kategorya, pagkatapos ay idagdag',
  'task.inventory.wizard.addLocationPlaceholder': 'Mag-type ng lokasyon, pagkatapos ay idagdag',
  'task.inventory.wizard.addChip': 'Idagdag',
  'task.inventory.wizard.removeChipAria': 'Alisin ang {{label}}',
  'task.inventory.wizard.expiryLeadsLabel': 'Ipaalam bago mag-expire ang Home Stock (mga araw)',
  'task.inventory.wizard.expiryLeadsHint': 'Opsyonal multi-select; laktawan kung ayaw mo ng mga alerto sa pag-expire.',
  'task.inventory.wizard.titleRequired': 'Kinakailangan ang pamagat',
  'task.inventory.wizard.categoriesRequired': 'Magdagdag ng kahit isang kategorya',
  'task.inventory.wizard.locationsRequired': 'Magdagdag ng kahit isang lokasyon',
  'task.inventory.wizard.summaryTitle': 'Pamagat',
  'task.inventory.wizard.summaryDesc': 'Paglalarawan',
  'task.inventory.wizard.summaryCategories': 'Mga kategorya',
  'task.inventory.wizard.summaryLocations': 'Mga lokasyon',
  'task.inventory.wizard.summaryList': 'Checklist',
  'task.inventory.wizard.summaryRecurrence': 'Iskedyul',
  'task.inventory.wizard.summaryDueTime': 'Takdang panahon',
  'task.inventory.wizard.summaryNotify': 'Ipaalam sa employer kapag natapos na',
  'task.inventory.wizard.summaryNotifyOn': 'Oo',
  'task.inventory.wizard.summaryNotifyOff': 'Hindi',
  'task.inventory.wizard.summaryExpiryLeads': 'Mga araw ng pag-expire ng lead',
  'task.inventory.wizard.summaryNone': '(wala)',
  'task.inventory.wizard.reviewCardHeading': 'Gawain ng Home Stock',
  'task.inventory.selectListLabel': 'Checklist',
  'task.inventory.selectListPlaceholder': 'Pumili…',
  'task.inventory.selectListRequired': 'Pumili ng checklist',
  'task.inventory.listHasNoItems': 'Ang checklist na ito ay wala pang mga item. Magdagdag muna ng mga item sa itaas.',
  'task.inventory.titleOptional': 'Opsyonal — ginagamit ang default na pamagat kung walang laman',
  'task.inventory.titlePlaceholder': 'hal. Kusina Home Stock ngayong linggo',
  'task.inventory.submitCreateTask': 'Lumikha ng gawain sa Home Stock',
  'task.inventory.createTaskError': 'Hindi makagawa ng gawain sa Home Stock',
  'task.inventory.createTaskSuccess': 'Nagawa ang gawain ng Home Stock',
  'task.inventory.dueDateInvalid': 'Pumili ng wastong takdang petsa',
  'task.complete.title': 'Kumpletuhin ang Gawain',
  'task.complete.subtitle': 'Magsumite ng patunay ng pagkumpleto ng gawain',
  'task.resubmit.photoHint': 'Maaari mong alisin ang mga maling larawan, pagkatapos ay kumuha o pumili ng mga bago.',
  'task.complete.photoSection': 'Mga larawan (1-3)',
  'task.complete.submittedPhotosOnly': 'Nagsumite ng mga larawan',
  'task.complete.photoHint': 'I-tap para kumuha ng larawan o pumili mula sa gallery',
  'task.complete.compressingPhotos': 'Kino-compress ang mga larawan...',
  'task.complete.takePhoto': 'Camera',
  'task.complete.choosePhoto': 'Gallery',
  'task.complete.photoAlt': 'Larawan ng gawain {{n}}',
  'task.complete.enlargePhotoAria': 'Tingnan ang buong laki ng larawan ng gawain',
  'task.complete.removePhoto': 'Alisin ang larawan',
  'task.complete.gpsSection': 'Lokasyon ng GPS',
  'task.complete.gpsOn': 'Pinagana',
  'task.complete.gpsOff': 'Hindi pinagana',
  'task.complete.gpsHint': 'Paganahin ang pag-record ng iyong lokasyon',
  'task.complete.noteSection': 'Tandaan',
  'task.complete.notePlaceholder': 'Magdagdag ng tala (opsyonal)...',
  'task.complete.completedAtLabel': 'Nakumpleto ang oras',
  'task.complete.completedAtRequired': 'Pakilagay ang nakumpletong petsa at oras',
  'task.complete.submit': 'Isumite',
  'task.complete.submitting': 'Isinusumite...',
  'task.complete.submitSuccess': 'Matagumpay na naisumite ang gawain',
  'task.complete.submitError': 'Nabigo ang pagsusumite',
  'task.complete.photoRequired': 'Mangyaring mag-upload ng hindi bababa sa 1 larawan',
  'task.complete.photoUploadError': 'Hindi makapag-upload ng mga larawan sa cloud storage. Suriin ang iyong koneksyon, subukang muli, at tiyaking pinapayagan ng GCS bucket CORS ang site na ito.',
  'task.complete.offlineSaved': 'Naka-save offline, magsi-sync kapag online',
  'task.resubmit.title': 'Isumiteng muli ang Gawain',
  'task.resubmit.subtitle': 'Baguhin at muling isumite batay sa feedback ng employer',
  'task.resubmit.previousNote': 'Nakaraang tala',
  'task.resubmit.submit': 'Muling isumite',
  'task.resubmit.submitSuccess': 'Matagumpay na naisumite muli',
  'task.action.back': 'Bumalik',
  'task.action.refresh': 'I-refresh',
  'task.action.delete': 'Tanggalin',
  'task.action.archive': 'Archive',
  'task.action.archiveConfirm': 'Sigurado ka bang gusto mong i-archive ang gawaing ito?',
  'task.action.archiveSuccess': 'Na-archive ang gawain',
  'task.action.archiveError': 'Nabigong i-archive ang gawain',
};
